import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import io from 'socket.io-client'
import Hammer from 'react-hammerjs'
import { HTML5Backend } from 'react-dnd-html5-backend-old'
import { DragDropContext } from 'react-dnd-old'
import {
    webSerialConnect,
    initHexState,
    syncHexState,
    updateHexStepMeta,
    clearHexSteps,
    setHexActiveStep,
} from '../../redux/actions/index'
import {
    flattenToMicroSlides,
    buildStateForMicroSlide,
    getNewBlockPosition,
} from './TutorialReplayEngine'
import unicodeToChar from '../../utils/unicodeToChar'
// import DragDropContext from 'react-dnd-old';
// import TouchBackend from 'react-dnd-old-touch-backend';
import getBytes from '../Simulate/BytesGeneration/convertBytes'
import { connect } from 'react-redux'
import HexBoard from './HexBoard'
import BottomPanel from './BottomPanel'
// import RightPanel from './RightPanel'
import SizesHelper from '../../helpers/Sizes'
import Sizes from '../logic/Sizes'
import ProgramToDrawing from './ProgramToDrawing'
import '../../css/logicTwo.css'
import './index.css'
import Modal from 'react-modal'
import renderPrgImage from '../../source/programImg'
import LogicPrgm from '../ReusableComponents/PrgmSlider/LogicPrgmTwo/LogicPrgm'
import * as atatus from 'atatus-spa'
import DialogModal from '../ReusableComponents/DialogModal/DialogModal'
import { sendBytes } from '../ReusableComponents/ByteTransfer'
import { readBytes } from '../ReusableComponents/ByteTransfer/byteTransfer'
import ProgramHeaderTwo from '../ReusableComponents/Header/ProgramHeaderTwo'
import Footer from '../ReusableComponents/FooterComponent'
import { continousPABytesReadToggle } from '../ReusableComponents/ByteTransfer'
import LogicStepsSlideshow from './LogicStepsSlideshow'
import {
    fetchHexSteps,
    normalizeSteps as normalizeHexSteps,
} from './LogicStepsApi'
import fetchAssemblyAccessories from '../AssemblyTwo/assemblyAccessoriesApi'
import { fetchAssemblySteps } from '../AssemblyTwo/assemblyStepsApi'
import defaultPortConnections from '../Assembly/PortConnections'
import {
    generateAidata,
    generateAiresetdata,
} from '../AppMode/AppModeAI/AppModeAiBytesGeneration'
import { getHederTextArr } from '../../utils/langaugeSupport'
import { PORTDATA } from '../Humanoid/defaultData'
import {
    decimalToMSBLSB,
    generateDeviceDataKey,
} from '../ReusableComponents/ByteTransfer/utils'
import {
    getDeviceName,
    isAi1ShowCondition,
    stopByteCondition,
} from '../../utils/utils'
import SavePopUpTwo from '../Code/CreateAction/SavePopUpTwo'
import {
    MdOutlineArrowBack,
    MdOutlineViewInAr,
    MdFullscreen,
    MdClosedCaption,
} from 'react-icons/md'
import { BsStars } from 'react-icons/bs'
import MakeHeader from '../ReusableComponents/Header/MakeHeader'
import MakeContext from '../Make/MakeContext'
import { GrPrevious, GrNext } from 'react-icons/gr'
import { RxReset } from 'react-icons/rx'
import ContentEngine from '../ContentEngine/ContentEngine'
import { connectSerialDeviceInitial } from '../WebSerialConnection/SerialUSBConnect'
import { deviceDetails, deviceMismatch } from '../../redux/actions/index'
import { getBrandDeviceName } from '../../hooks/useBrandConfig'


const DISPLAY_TO_INTERNAL_PORT = {
    M2: 'M3',
    S1: 'servo_motor1',
    S2: 'servo_motor2',
}
const resolveInternalPort = (port) => {
    const device = sessionStorage.getItem('connectedDevice')
    const isTokiFamily = ['Toki', 'Poki'].includes(device)
    if (isTokiFamily && port && DISPLAY_TO_INTERNAL_PORT[port]) {
        return DISPLAY_TO_INTERNAL_PORT[port]
    }
    return port
}

var _ = require('lodash')
var countLogic
var oldDeltaX, oldDeltaY, panning
var idss = []
var IDIS = ''
var clientX, clientY
var drawing,
    drawingNew,
    defaultScale = 1
var panning = false,
    zooming = false,
    dontTriggerClick = false
var finalOffset = { left: 0, top: 0 }
let newArr = []
let num = 0
const history = createBrowserHistory()

// Maps JSON tutorial block types to internal hex types
const TUTORIAL_BLOCK_TYPE_MAP = {
    action: 'hardware',
    wait: 'wait',
    end: 'end',
    decision: 'condition',
    condition: 'condition',
    loop: 'loop',
    repeat: 'repeat',
    sensor: 'sensor',
    variable: 'variable',
    if: 'if',
    stop: 'end',
    end_decision: 'end_condition',
    end_if: 'end_condition',
    end_condition: 'end_condition',
    end_loop: 'end_loop',
    end_sensor: 'end_sensor',
    end_variable: 'end_variable',
}

const defaultLogic = {
    program: [
        {
            type: 'start',
            state: {
                bic1: false,
                bic2: false,
                bic3: false,
                bid1: false,
                bid2: false,
                bif1: false,
                bif2: false,
                bif3: false,
                bidata1: false,
                bidata2: false,
                asgn1: false,
                asgn2: false,
                asgn3: false,
                asgn4: false,
                asgn5: false,
            },
            bic1: false,
            bic2: false,
            bic3: false,
            bid1: false,
            bid2: false,
            bif1: false,
            bif2: false,
            bif3: false,
            bid3: false,
            bmp3: false,
            bidata1: false,
            bidata2: false,
            asgn1: false,
            asgn2: false,
            asgn3: false,
            asgn4: false,
            asgn5: false,
        },
    ],
    end: { type: 'end', state: 'repeat' },
    insertState: false,

    offset: { left: 0, top: 0 },
    scale: 1,
    currentProgramGuide: 0,
    active: [-1, -1],
    bottomPanel: 'border',
    CUSTOMGROUPACTIONS12: {},
}

// CHNAGE by: SOUMITYA

// const customStyles = {
//   content: {
//     top: "50%",
//     left: "50%",
//     height: "28%",
//     width: " 30%",
//     right: "auto",
//     bottom: "auto",
//     marginRight: "-50%",
//     transform: "translate(-50%, -50%)",
//     backgroundColor: "#9ecee8",
//     border: "2px solid #188dcc",
//     zIndex: 1,
//   },
// };

const saveToLocalStorage = () => {
    let programMode = sessionStorage.programMode
    let connectedDevice = sessionStorage.connectedDevice
    let version = sessionStorage.deviceVersion

    let updatelocalStorage = JSON.parse(localStorage.getItem('recoveryData'))
    if (programMode in updatelocalStorage) {
        if (connectedDevice in updatelocalStorage[programMode]) {
            updatelocalStorage[programMode][connectedDevice][version] =
                sessionStorage
            localStorage.setItem(
                'recoveryData',
                JSON.stringify(updatelocalStorage)
            )
        } else {
            updatelocalStorage[programMode][connectedDevice] = {
                [version]: sessionStorage,
            }
            localStorage.setItem(
                'recoveryData',
                JSON.stringify(updatelocalStorage)
            )
        }
    } else {
        updatelocalStorage[programMode] = {
            [connectedDevice]: {
                [version]: sessionStorage,
            },
        }
        localStorage.setItem('recoveryData', JSON.stringify(updatelocalStorage))
    }
}

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        height: '23%',
        width: ' 25%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        // backgroundColor: "#9ecee8",
        // border: "2px solid #188dcc",

        border: '5px solid rgb(255,140,25)',
        borderRadius: '20px',

        overflow: 'initial',
        // zIndex: 1,
    },
}

const customStylesUpload = {
    content: {
        top: '50%',
        left: '50%',
        height: ' 30%',
        width: ' 30%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        zIndex: 1000000,
        borderRadius: '15px',
        transform: 'translate(-50%, -50%)',
        border: '5px solid orange',
    },
}

let newId = 0

class LogicTwo extends Component {
    static contextType = MakeContext
    constructor(props) {
        super(props)
        this.sendDataRef = React.createRef()
        this.sendDataRef.current = { sendDataAsPacket: false, readVal: '' }

        this.replayFileInputRef = React.createRef()
        this.replayTimerId = null

        this.subtitleRef = React.createRef()
        this.typewriterInterval = null

        var { logic } = this.props

        var tutorialLogic = sessionStorage.getItem('tutorialLogic')

        var tutorialDescArray = []
        var selectionType = localStorage.getItem('programMode')

        if (selectionType == 'learn') {
            var tutorialDesc = JSON.parse(
                sessionStorage.getItem('tutorialLogic')
            )
            // tutorialDescArray.push(JSON.parse(tutorialDesc).logic1)
            // tutorialDescArray.push(JSON.parse(tutorialDesc).logic2)
        }

        drawing = ProgramToDrawing(
            undefined,
            logic.program,
            logic.end,
            logic.currentProgramGuide,
            logic.active,
            this.add,
            logic.insertState,
            this.insertNode,
            this.insertBtwnNode,
            this.deleteNode
        )
        var curLogicScreen
        curLogicScreen = 'hexa'
        // this.click = this.click.bind(this)
        // this.add = this.add.bind(this)

        this.state = {
            hexType: '',
            // Gates the board render until the target step has actually been
            // built. Without this, navigating away and back re-mounts this screen
            // with the PREVIOUS visit's program still in Redux, so the stale board
            // (e.g. step 13) flashes for ~1s until the async loadLogicSteps →
            // clearAndRebuildToStep resets it to the correct step. Only enforced in
            // Make/tutorial mode (see render); standalone use is unaffected.
            stepsReady: false,
            uploadOpen: false,
            hasUploaded: false,
            showSkipUploadModal: false,
            tutorialDesc: tutorialDesc,
            tutorialLogic: JSON.parse(tutorialLogic),
            modalIsOpen: false,
            showReconnectModal: false,
            reconnectStatus: null, // null | 'scanning' | 'mismatch'
            clearProgramModal: false,
            usbOpen: false,
            isusb: false,
            isHelp: false,
            currentLogicScreen: curLogicScreen,
            currentNode: {},
            visible: false,
            currentNodeIndex: 0,
            nodeCount: 1,
            detected: false,
            readyForSimulation: '',
            checkEndProgram: false,
            excitDataLimitPopup: false,
            clickedBottom: false,
            isConnected: this.props.isConnected,
            uploadSucessError: { isShow: false, message: '' },
            lowerVersionPcAiToolShow: false,
            slideDirection: sessionStorage.getItem('slideDirection'),
            filePopup: false,
            logicSteps: null,
            microSlides: [],
            stepsSlideIndex: 0,
            isReplaying: false,
            replayIndex: 0,
            replayMessage: '',

            aiVoiceover: sessionStorage.getItem('aiVoiceToggle') !== 'false',
            currentStep: 1,
            subtitleVisible: false,
            showSubtitleDisplay: false,
            typewriterText: '',
            aiSpeaking: true,
            assemblySteps: null,
            tutorialDeviation: false,
        }
        this.messageHandler = this.messageHandler.bind(this)

        this.audioRef = React.createRef()
        this.appContainerRef = React.createRef()

        window.addEventListener('load', async (e) => {
            console.log('HEY_CALIIN', this.props.state)
            navigator.serial.addEventListener('connect', (e) => {
                var user = 1
                sessionStorage.setItem('user', JSON.stringify(user))
                this.handleUsb()
                if (window.location.pathname === '/deviceSelection') {
                    sessionStorage.setItem('autoCunnection', 'true')
                }
                // window.location.reload(false)
            })

            navigator.serial.addEventListener('disconnect', async (e) => {
                var user = 0
                sessionStorage.setItem('user', JSON.stringify(user))
                this.handleUsb()
                const p_Port = this.props.webSerial.port
                try {
                    await p_Port.close()
                } catch (e) {}
            })
            try {
                const portList = await navigator.serial.getPorts()

                if (portList.length === 1) {
                    console.log(portList, 'Hardware connected')
                    let port1 = portList[0]
                    await props.webSerialConnect({ port: port1 }) // dispatching function of redux
                    //debugger;
                    this.setState.p1({
                        selected: true,
                        port: portList[0],
                    })
                } else {
                    console.log('No hardware')

                    this.setState.p1(this.state.p1)
                }
            } catch (err) {
                console.log(err.message)
            }
        })
    }

    // Helpers for preview mode / project id selection
    getSearchParams = () => {
        let search =
            this.props.location?.search ||
            this.props.history?.location?.search ||
            window.location.search

        // Hash router fallback: extract query string from the hash if search is empty
        if (!search && window.location.hash.includes('?')) {
            search = window.location.hash.substring(
                window.location.hash.indexOf('?')
            )
        }

        return new URLSearchParams(search)
    }

    getIsPreviewMode = () => {
        if (this.getSearchParams().get('preview') === 'true') return true
        // Make-mode preview runs on the route `/makeAdmin/:subId/preview`, which
        // carries NO `?preview=true` query param — SubprogramRunner signals
        // staging via `ContentEngine.staging = preview` instead. Hex still
        // rendered fine here because loadLogicSteps uses the props.data that
        // SubprogramRunner passes, but ensureAssemblyConnections has to fetch a
        // *different* screen (the assembly one) itself. Without this fallback it
        // saw preview=false and hit the LIVE `/api/assembly/...` endpoint (often
        // unpublished/empty) instead of `/api/staging/assembly/...`, so the
        // panel hydrated with zero connections. See ContentEngine.staging.
        try {
            if (ContentEngine?.staging) return true
        } catch (e) {
            // ignore — fall back to non-preview
        }
        return false
    }

    getCurrentProjectId = () => {
        const urlParams = this.getSearchParams()
        const queryProjectId = urlParams.get('projectId')

        if (queryProjectId) return queryProjectId
        if (this.props.projectId) return this.props.projectId

        return sessionStorage.getItem('apiProjectId') || 'talking-dragon'
    }

    getCurrentScreenId = () => {
        const urlParams = this.getSearchParams()
        const queryScreenId = urlParams.get('screenId')
        if (queryScreenId) return queryScreenId
        if (this.props.screenId) return this.props.screenId
        return sessionStorage.getItem('apiScreenId') || null
    }

    getAssemblyScreenId = (fallbackId) => {
        const urlParams = this.getSearchParams()
        const queryAssemblyScreenId = urlParams.get('assemblyScreenId')
        if (queryAssemblyScreenId) return queryAssemblyScreenId
        // SubprogramRunner computes this fresh for the CURRENT hex screen (by
        // scanning back to the preceding assembly screen) and passes it down as
        // a prop. It is the authoritative source when jumping straight here via
        // timeline navigation — the fallbacks below can be missing/stale on a
        // direct jump (no query params, hex content may omit assemblyScreenId,
        // and sessionStorage may still hold a previous screen's id). Without
        // this, getAssemblyScreenId returned null and ensureAssemblyConnections
        // bailed out, leaving assemblyTwo.PortConnections empty.
        if (this.props.assemblyScreenId) return this.props.assemblyScreenId
        if (fallbackId) return fallbackId
        // Last-resort: derive it ourselves from ContentEngine, exactly like
        // SubprogramRunner does — scan back from the current screen to the most
        // recent assembly screen. This guarantees a value on a direct jump even
        // if the prop/sessionStorage paths are empty or stale.
        const fromEngine = this.resolveAssemblyScreenIdFromEngine()
        if (fromEngine) return fromEngine
        return sessionStorage.getItem('assemblyScreenId') || null
    }

    // Mirror of SubprogramRunner's backward scan: find the id of the assembly
    // screen that precedes the current hex screen in the same subprogram.
    resolveAssemblyScreenIdFromEngine = () => {
        try {
            const sub = ContentEngine.getCurrentSubprogram?.()
            const screens = sub?.screens
            if (!Array.isArray(screens)) return null
            for (let i = ContentEngine.screenIndex - 1; i >= 0; i--) {
                if (screens[i]?.type === 'assembly') {
                    return screens[i].id
                }
            }
        } catch (e) {
            // ignore — fall through to other sources
        }
        return null
    }

    componentWillMount = () => {
        sessionStorage.setItem('isReadingZingPA', false)
        atatus.beginTransaction('Logic Screen')
        const { program, end, insertState, currentProgramGuide, active } =
            this.props.logic

        drawing = ProgramToDrawing(
            undefined,
            program,
            end,
            currentProgramGuide,
            active,
            this.add,
            insertState,
            this.insertNode,
            this.insertBtwnNode,
            this.deleteNode
        )

        // Same grid-shift correction as componentWillUpdate, for the case where
        // the screen mounts directly onto a mid-tutorial config step.
        const correctedActive = this.correctTutorialActiveCoords(
            this.props.logic,
            this.state.stepsSlideIndex
        )
        if (correctedActive) {
            this.props.logic.active = correctedActive
            drawing = ProgramToDrawing(
                undefined,
                program,
                end,
                currentProgramGuide,
                correctedActive,
                this.add,
                insertState,
                this.insertNode,
                this.insertBtwnNode,
                this.deleteNode
            )
        }
    }
    componentWillUnmount() {
        this.props.worker.removeEventListener('message', this.messageHandler)
        atatus.endTransaction('Logic Screen')

        if (this.replayTimerId) {
            clearTimeout(this.replayTimerId)
            this.replayTimerId = null
        }

        document.removeEventListener('mousedown', this.handleClickOutside)
        if (this.typewriterInterval) {
            clearInterval(this.typewriterInterval)
            this.typewriterInterval = null
        }

        // Mark component as unmounted to prevent state updates
        this._isMounted = false
    }
    componentWillUpdate(nextProps, nextState) {
        const { program, end, insertState, currentProgramGuide, active } =
            nextProps.logic

        console.log('Program before drawing:', program)
        console.log('End state:', end)

        // Add null/undefined checks to prevent crash
        if (!program || !end) {
            console.warn(
                'Program or end is undefined, skipping ProgramToDrawing'
            )
            return
        }

        drawing = ProgramToDrawing(
            undefined,
            program,
            end,
            currentProgramGuide,
            active,
            this.add,
            insertState,
            this.insertNode,
            this.insertBtwnNode,
            this.deleteNode
        )

        // Snap `active` onto the configured block's TRUE rendered position when
        // a tutorial container block shifted the grid (otherwise the panel-open
        // guard sees a blank cell and refuses to open the block). See
        // correctTutorialActiveCoords for the full explanation.
        const slideIndex =
            nextState?.stepsSlideIndex != null
                ? nextState.stepsSlideIndex
                : this.state.stepsSlideIndex
        const correctedActive = this.correctTutorialActiveCoords(
            nextProps.logic,
            slideIndex
        )
        if (correctedActive) {
            nextProps.logic.active = correctedActive
            drawing = ProgramToDrawing(
                undefined,
                program,
                end,
                currentProgramGuide,
                correctedActive,
                this.add,
                insertState,
                this.insertNode,
                this.insertBtwnNode,
                this.deleteNode
            )
        }

        console.log('Drawing result:', drawing)
    }
    OpenReadComPort = async () => {
        const port = this.props.webSerial.port
        console.log('PORTLIST', port)
        // console.log(port, "pPort");
        try {
            // await port.close();
            await port.open({ baudRate: 120000 })
        } catch (e) {
            console.log(e)
        }
        // this.writePort("notWrite");
        // let valresponceTp0 = "",
        //   valdis = "";
        // // setTimeout(async () => {
        // if (this.state.readbytes) {
        // this.readdata();
        // }

        // }, 1000);
    }

    stopPaOnBack = () => {
        if (this.state.isPcActive) {
            this.setState({ readbytes: false })
            this.setState({ isPcActive: false })
        }
        if (this.state.isReading) {
            this.setState({ isReading: false })
            sessionStorage.setItem('isReadingZingPA', false)
            // this.continuesPAstop()
        }
    }

    handleHeaderTabClick = (index) => {
        if (index > 3) {
            return
        }

        this.stopPaOnBack()

        if (index === 0) {
            this.props.history.push('/playdynamexNew')
        }
        if (index === 1) {
            if (!sessionStorage.getItem('connectedDevice')) {
                sessionStorage.setItem(
                    'connectedDevice',
                    sessionStorage.getItem('allowedDevice') || 'Toki'
                )
                sessionStorage.setItem('deviceVersion', '1')
            }
            this.props.history.push('/assemblyTwo')
        }
        if (index === 2) {
            this.props.history.push('/logicTwo')
        }
        if (index === 3) {
            this.props.history.push('/SimulateNew')
        }
    }

    handleUsb = (e) => {
        this.setState({ isusb: !this.state.isusb })
    }
    helpBtn = (e) => {
        this.setState({ isHelp: !this.state.isHelp })
    }
    clearProgramTrue = () => {
        this.setState({ clearProgramModal: true })
    }
    clearProgramfalse = () => {
        this.setState({ clearProgramModal: false })
    }
    clearProgram = async () => {
        sessionStorage.setItem('isSave', JSON.stringify(false))
        sessionStorage.removeItem('logicTwo')
        sessionStorage.removeItem('programEnd')
        // window.location.reload(false)

        this.props.update(JSON.parse(JSON.stringify(defaultLogic)))
        await new Promise((reslove) => setTimeout(reslove, 0))

        sessionStorage.removeItem('EndSwitch')
        ///////// Humanoid Program Data ///////////
        sessionStorage.removeItem('humanoidProgramData')
        sessionStorage.removeItem('PET')

        this.setState({ clearProgramModal: false })
    }

    _syncShellProps = () => {
        const ctx = this.context
        if (!ctx || !ctx.setHeaderProps) return
        const stepsData = this.state.logicSteps
        const activeSlideIndex = this.state.stepsSlideIndex
        const totalSlides = this.getStepsSlideCount(stepsData)
        const microSlides = this.state.microSlides

        let slideTitle = ''
        if (activeSlideIndex === totalSlides) {
            slideTitle = this.state.hasUploaded
                ? (stepsData?.finalStepTitle || 'Excellent!')
                : (stepsData?.uploadStepTitle || 'Upload Code')
        } else if (activeSlideIndex === totalSlides + 1) {
            slideTitle = stepsData?.uploadStepTitle || 'Upload Code'
        } else if (
            stepsData?.version === '2.0' &&
            microSlides &&
            microSlides.length > 0
        ) {
            slideTitle = microSlides[activeSlideIndex]?.title || ''
        } else if (stepsData?.version === '2.0' && stepsData?.steps) {
            slideTitle = stepsData.steps[activeSlideIndex]?.title ?? ''
        }

        const stepTitles =
            microSlides && microSlides.length > 0
                ? microSlides.map((slide) => slide?.title || '')
                : stepsData?.steps?.map((step) => step?.title || '') || []

        ctx.setHeaderProps({
            title: stepsData?.meta?.title || stepsData?.title || 'Toki',
            showJumpTo: false,
            titlePosition: 'left',
            help_btnPosition: 'right',
            isGoBack: true,
            goBack: this.goBack,
            showSave: true,
            showHexHelp: true,
            showBluetoothBtn: true,
            isSaveToBoard: this.getIsSaveToBoard(),
            isShowNewUI: true,
            fileSaveClick: () => {
                // In expansion kit tutorial flow, save progress to backend
                if (sessionStorage.getItem('expansionKit') && ctx.saveProgress) {
                    // Persist the current step-within-screen to localStorage
                    const subId = this.getCurrentProjectId()
                    const screenIdx = ContentEngine.screenIndex ?? 0
                    localStorage.setItem(
                        `progress_step_${subId}_${screenIdx}`,
                        this.state.stepsSlideIndex.toString()
                    )
                    ctx.saveProgress()
                } else {
                    this.setState({ filePopup: true })
                }
            },
            currentStep: activeSlideIndex + 1,
            totalSteps: this.getStepsSlideCount(stepsData),
            stepTitles,
            onStepClick: (stepNum) => {
                ContentEngine.breakSequentialChain()
                const slideIndex = stepNum - 1
                this.clearAndRebuildToStep(slideIndex)
                this.setState({
                    stepsSlideIndex: slideIndex,
                    showSubtitleDisplay: true,
                })
                if (this.state.aiVoiceover) this.playAudioForStep(slideIndex)
            },
        })

        ctx.setFooterProps({
            stepCounter: `Step ${activeSlideIndex + 1} of ${totalSlides + 1}`,
            stepTitle: slideTitle,
            nextLabel: activeSlideIndex === totalSlides ? 'Continue' : 'Next',
            onPrev: this.handleStepsPrev,
            onNext: this.handleStepsNext,
        })

        if (ctx.setToolbarProps) {
            ctx.setToolbarProps({
                aiVoiceover: this.state.aiVoiceover,
                onAiToggle: () => {
                    this.handleAiVoiceoverToggle()
                    this.setState({
                        subtitleVisible: true,
                        showSubtitleDisplay: true,
                    })
                },
                onFullscreen: this.handleFullscreen,
                onReset: this.resetTutorial,
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // If data prop changed (ContentEngine re-fetched new screen content),
        // rebuild microSlides and logicSteps so instructions stay in sync.
        if (prevProps.data !== this.props.data && this.props.data) {
            this.loadLogicSteps()
            return
        }

        // If the URL query changed (e.g., switching preview project), reload steps
        const prevSearch = prevProps.location?.search || window.location.search
        const currSearch = this.props.location?.search || window.location.search
        if (prevSearch !== currSearch) {
            this.loadLogicSteps()
        }

        saveToLocalStorage() // Keep your existing logic

        // Existing deviation check
        if (
            prevProps.logic.PortConnections !== this.props.logic.PortConnections
        ) {
            this.checkTutorialDeviation()
        }

        this.autoAdvanceStepIfNeeded()

        const stepChanged =
            prevState.stepsSlideIndex !== this.state.stepsSlideIndex
        const aiToggled = prevState.aiVoiceover !== this.state.aiVoiceover
        const stepsLoaded = !prevState.logicSteps && this.state.logicSteps // Handle initial load

        // Save to session storage whenever the step changes
        if (stepChanged) {
            const storageKey = `logic_step_${this.getCurrentProjectId()}_${this.getCurrentScreenId() || 'default'}`
            sessionStorage.setItem(
                storageKey,
                this.state.stepsSlideIndex.toString()
            )
        }

        if (stepChanged || aiToggled || stepsLoaded) {
            const text = this.getCurrentInstruction()

            // If data just loaded for the first time, or step changed, play audio
            if ((stepsLoaded || stepChanged) && this.state.aiVoiceover) {
                this.playAudioForStep(this.state.stepsSlideIndex)
            }

            // Ensure subtitle box stays open if AI is toggled on
            if (aiToggled && this.state.aiVoiceover) {
                this.setState({ showSubtitleDisplay: true })
            }

            this.runTypewriterEffect(text)
        }
        if (stepChanged || stepsLoaded || aiToggled) {
            this._syncShellProps()
        }
    }
    /**
     * Ensures the BottomPanel has the assembly-derived data it needs, even when
     * the user jumps straight to LogicTwo via timeline navigation without ever
     * mounting AssemblyTwo.
     *
     * The action panel needs TWO Redux slices, both produced by AssemblyTwo on
     * mount (refreshAssemblyAccessories -> fetchAssemblyAccessories):
     *   - state.assemblyTwo.PortConnections : which ports are wired
     *   - state.concept.componentProps      : how to render each wired component
     * When LogicTwo is opened directly, AssemblyTwo never mounts, so both stay
     * empty and the panel renders blank. This method runs the same fetch and
     * syncs both slices into Redux. It only runs when an assemblyScreenId can be
     * resolved (see getAssemblyScreenId).
     */
    ensureAssemblyConnections = async (fallbackId) => {
        try {
            const isPreviewMode = this.getIsPreviewMode()
            const apiProjectId = this.getCurrentProjectId()
            const assemblyScreenId = this.getAssemblyScreenId(fallbackId)

            if (!assemblyScreenId) {
                console.log(
                    'LogicTwo: No assemblyScreenId resolved; skipping assembly hydration'
                )
                return
            }

            // ── STEP 1: Hydrate `concept` (component metadata) ──
            // fetchAssemblyAccessories loads the component DICTIONARY — it tells
            // the panel WHAT a "servo_motor" is (name, image, ranges). It writes
            // sessionStorage('concept'); we mirror that into Redux. Concept FIRST,
            // because the componentSelection reducer's default case rewrites
            // sessionStorage('concept') from its current (empty) state on any
            // unhandled action, which would clobber what we just fetched.
            await fetchAssemblyAccessories(
                apiProjectId,
                isPreviewMode,
                assemblyScreenId
            )
            const conceptStr = sessionStorage.getItem('concept')
            if (conceptStr) {
                const conceptData = JSON.parse(conceptStr)
                if (conceptData.componentProps) {
                    this.props.updateComponentProps(conceptData.componentProps)
                }
                if (conceptData.internalaccessories) {
                    this.props.updateInternalAccessories(
                        conceptData.internalaccessories
                    )
                }
                if (conceptData.counter) {
                    this.props.updateComponentSelection(conceptData.counter)
                }
            }

            // ── STEP 2: Hydrate `assemblyTwo.PortConnections` (the wiring) ──
            // fetchAssemblySteps loads the actual user actions/steps. We loop
            // through them to rebuild WHERE each component is plugged in — exactly
            // what AssemblyTwo.buildWorkspaceForStep does after the slideshow.
            const stepsData = await fetchAssemblySteps(
                apiProjectId,
                isPreviewMode,
                assemblyScreenId
            )
            const steps = Array.isArray(stepsData?.steps) ? stepsData.steps : []

            if (steps.length === 0) {
                console.log(
                    `LogicTwo: fetched 0 assembly steps for screen ${assemblyScreenId}`
                )
                return
            }

            const connectedDevice = sessionStorage.getItem('connectedDevice')
            const isTokiFamily = ['Toki', 'Poki'].includes(connectedDevice)

            // Start from a fully-null copy of the port map, then apply each step.
            const portConnections = { ...defaultPortConnections }
            Object.keys(portConnections).forEach((key) => {
                portConnections[key] = null
            })
            const workspaceComponents = {}

            steps.forEach((step) => {
                const type = step.component
                const displayPort = step.port
                if (!type || !displayPort) return

                const port = resolveInternalPort(displayPort)

                if (!workspaceComponents[type]) {
                    workspaceComponents[type] = []
                }
                const index = workspaceComponents[type].length
                workspaceComponents[type].push({
                    left: 100,
                    top: 100,
                    connectedTo: port,
                })

                portConnections[port] = { type, index }

                // Mirror multi-port motors (M1->M2, M3->M4) for non-Toki boards,
                // matching AssemblyTwo.applyPortConnection.
                if (!isTokiFamily && port === 'M1') {
                    portConnections['M2'] = { type, index }
                }
                if (!isTokiFamily && port === 'M3') {
                    portConnections['M4'] = { type, index }
                }
            })

            const prevWorkspace = this.props.assemblyTwo?.workspace || {}
            const workspace = {
                ...prevWorkspace,
                bibox: prevWorkspace.bibox || { top: 208, left: 328 },
                components: workspaceComponents,
                offset: prevWorkspace.offset || { top: 0, left: 0 },
                scale: prevWorkspace.scale || 1,
            }

            this.props.updateAssemblyTwoWorkspace(workspace)
            this.props.updateAssemblyTwoPortConnections(portConnections)

            console.log(
                'LogicTwo: hydrated assembly data PortConnections:',
                portConnections
            )
        } catch (err) {
            console.error(
                'LogicTwo: Error in ensureAssemblyConnections:',
                err
            )
        }
    }

    componentDidMount = async () => {
        // Mark component as mounted to prevent state updates after unmount
        this._isMounted = true

        // Ensure assemblyTwo connections are populated before loading logic steps
        // await this.ensureAssemblyConnections()

        this.loadLogicSteps()

        console.log('logicSteps: ', this.state.logicSteps)

        console.log('Initial step from props:', this.props.initialStep)

        if (this.props.initialStep) {
            this.setState({ stepsSlideIndex: this.props.initialStep - 1 })
        } else {
            // Priority 1: saved step from explicit Save button (expansion kit flow)
            const subId = this.getCurrentProjectId()
            const screenIdx = ContentEngine.screenIndex ?? 0
            const localStepKey = `progress_step_${subId}_${screenIdx}`
            const localSavedStep = localStorage.getItem(localStepKey)
            if (localSavedStep && !isNaN(localSavedStep)) {
                this.setState({ stepsSlideIndex: parseInt(localSavedStep, 10) })
            } else {
                // Priority 2: session-level step restore
                const storageKey = `logic_step_${this.getCurrentProjectId()}_${this.getCurrentScreenId() || 'default'}`
                const savedStep = sessionStorage.getItem(storageKey)
                if (savedStep && !isNaN(savedStep)) {
                    this.setState({ stepsSlideIndex: parseInt(savedStep, 10) })
                }
            }
        }

        document.addEventListener('mousedown', this.handleClickOutside)

        // var socket = io.connect("http://localhost:3008");
        // socket.emit("_usbDetection", "Hi");
        // socket.on("/usbDetection1", (data) => {
        //   // console.log("...............1", data);
        //   // // let kill = Array.from(data);
        //   // // console.log("...............5", kill);
        //   // if (data == 1) {
        //   //   this.handleUsb(true);
        //   //   console.log("LLLLLLLLLLLLLLL", data);
        //   // } else {
        //   //   this.handleUsb(false);
        //   // }
        // });
        // await new Promise((resolve) =>
        //     setTimeout(() => {
        //         this.setState({
        //             showUpload: true,
        //         })
        //         resolve()
        //     }, 2000)
        // )
        let data = JSON.parse(sessionStorage.getItem('user'))

        if (data === 1) {
            this.setState({
                isusb: true,
            })
            console.log('Logic AD !!')
            // this.setState({ isusb: true });
        }
        if (data === 0) {
            this.setState({
                isusb: false,
            })
            console.log('Logic AD')
            // this.setState({ isusb: false });
        }
        // socket.on("/usbDetection", (data) => {
        //   console.log("DATAE:----", data);
        //   this.setState({ detected: data.detected, usbOpen: !data.detected });
        // });
        // this.setState({ hexType: "wait" })
        if (sessionStorage.getItem('programEnd') != null) {
            this.setState({
                readyForSimulation: sessionStorage.getItem('programEnd'),
            })
        }

        this.props.worker.addEventListener('message', this.messageHandler)

        // Check tutorial deviation after mount
        setTimeout(() => {
            this.checkTutorialDeviation()
        }, 500)
    }

    //read data from serial worker
    messageHandler = (e) => {
        // if (e.data.type === 'read' && e.data.value.includes('AISOK')) {
        //     const doneObj = { sendDataAsPacket: true, readVal: 'AISOK' }
        //     this.sendDataRef.current = doneObj
        // } else if (e.data.type === 'read' && e.data.value.includes('AIROK')) {
        //     const doneObj = { sendDataAsPacket: true, readVal: 'AIROK' }
        //     this.sendDataRef.current = doneObj
        // } else
        if (e.data.type === 'read' && e.data.value.includes('OK')) {
            const doneObj = { sendDataAsPacket: true, readVal: 'OK' }
            this.sendDataRef.current = doneObj
        }
        if (e.data.type === 'actionRead') {
            let { arrayData, stringData } = e.data.value
            const pattern = /^65,73,.*255,245$/
            const isPatternMatch = pattern.test(arrayData.join(','))
            if (isPatternMatch) {
                this.sendDataRef.current = {
                    sendDataAsPacket: true,
                    readVal: arrayData,
                }
            }
        }
    }

    timeoutPromise = (ms) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                console.log('HHHHHHHHHH Time Out')
                reject(new Error('Timeout exceeded'))
            }, ms)
        })
    }

    checkOk = async () => {
        return new Promise(async (resolve, reject) => {
            try {
                while (true) {
                    // let sendData_read = sessionStorage.getItem('sendData_read')
                    let sendData_read = this.sendDataRef.current
                    if (sendData_read) {
                        // sendData_read = JSON.parse(sendData_read)
                        if (sendData_read.sendDataAsPacket) {
                            return resolve(sendData_read.readVal)
                        }
                    }

                    await new Promise((reslove) => {
                        setTimeout(reslove, 100)
                    })
                }
            } catch (e) {
                console.log(e)
            }
        })
    }

    constraintOffset = (offset) => {
        var el = document.getElementById('logicOffsetTransformer', this.props)
        const BBox = el.getBBox()
        const { height, width } = this.props.assembly
        const scale = this.props.logic.scale * defaultScale
        if (offset.left * scale > width / 2) offset.left = width / (2 * scale)
        else if (offset.left < -BBox.width + width / (2 * scale))
            offset.left = -BBox.width + width / (2 * scale)
        if (offset.top * scale > height / 2) offset.top = height / (2 * scale)
        else if (offset.top < -BBox.height + height / (2 * scale))
            offset.top = -BBox.height + height / (2 * scale)
    }

    /**
     * Pan event handler : does not update state for smooth panning. Also throttles the event
     */
    pan = (e) => {
        if (panning) return
        panning = true
        var el = document.getElementById('logicOffsetTransformer')
        var BBox = el.getBBox()
        const { offset } = this.props.logic

        const { height, width } = this.props.assembly

        finalOffset.left = offset.left + e.deltaX
        finalOffset.top = offset.top + e.deltaY
        if (finalOffset.left > width / 2) finalOffset.left = width / 2
        else if (finalOffset.left < -BBox.width + width / 2)
            finalOffset.left = -BBox.width + width / 2
        if (finalOffset.top > height / 2) finalOffset.top = height / 2
        else if (finalOffset.top < -BBox.height + height / 2)
            finalOffset.top = -BBox.height + height / 2
        el.setAttribute(
            'transform',
            'translate(' + finalOffset.left + ',' + finalOffset.top + ')'
        )
        panning = false
    }

    /**
     * Set dontTriggerClick variable to true
     */
    panStart = () => {
        dontTriggerClick = true
    }
    /**
     * Update state variables
     */
    panEnd = (e) => {
        var { logic } = this.props
        logic.offset.left = finalOffset.left
        logic.offset.top = finalOffset.top
        var logicState = {}
        logicState['type'] = this.state.currentLogicScreen
        logicState['state'] = logic

        this.props.update(logic, () => (panning = false))
    }
    panEndNew = () => {
        panning = false
        oldDeltaX = 0
        oldDeltaY = 0
    }

    zoom = (scale, clientX, clientY) => {
        var { height, width } = this.props.assembly
        var { logic } = this.props
        var clientY = height
        if (zooming) return
        var { height, width } = this.props.assembly
        var { logic } = this.props
        var clientY = height

        if ((logic.scale < 0.5 && scale < 1) || (logic.scale > 2 && scale > 1))
            return
        // zooming = true;
        var clientY = height
        // client = (offset + x/y) * scale
        // client of oldx/y = client of newx/y (current mouse position)
        // oldx/y = client / scale - offset
        // (newoffset + oldx/y) * newscale = (oldOffset + oldx/y) * oldscale
        const oldX = clientX / (logic.scale * defaultScale) - logic.offset.left

        const oldY = clientY / (logic.scale * defaultScale) - logic.offset.top
        logic.offset.left = (logic.offset.left + oldX) / scale - oldX
        logic.offset.top = (logic.offset.top + oldY) / scale - oldY

        logic.scale *= scale

        this.constraintOffset(logic.offset)
        var logicState = {}
        logicState['type'] = this.state.currentLogicScreen
        logicState['state'] = logic

        this.props.update(logic, () => {
            zooming = false
        })
    }

    /**
     * Pinch Out event handler
     */
    pinchOut = (e) => {
        this.zoom(6 / 5, e.center.x, e.center.y)
        e.preventDefault()
        return false
    }

    /**
     * Pinch In event handler
     */
    pinchIn = (e) => {
        this.zoom(5 / 6, e.center.x, e.center.y)
        e.preventDefault()
        return false
    }
    pinchOutNew = (e) => {
        this.zoomNew(12 / 11, e.center.x, e.center.y)
        e.preventDefault()
        return false
    }
    /**
     * Pinch In event handler
     */
    pinchInNew = (e) => {
        this.zoomNew(11 / 12, e.center.x, e.center.y)
        e.preventDefault()
        return false
    }
    /**
     * Reset pinch variables
     */
    pinchEnd = () => {
        zooming = false
    }
    /**
     * Wheel event handler
     */
    wheel = (e) => {
        // e.preventDefault();
        const { clientX, clientY, deltaY } = e
        if (deltaY > 0) {
            this.zoom(5 / 6, clientX, clientY)
        } else {
            this.zoom(6 / 5, clientX, clientY)
        }
        return false
    }
    wheelNew = (e) => {
        const { clientX, clientY, deltaY } = e
        if (deltaY > 0) this.zoomNew(5 / 6, clientX, clientY)
        else this.zoomNew(6 / 5, clientX, clientY)
        // e.preventDefault();
        return false
    }

    click = (row, col) => {
        // alert("CLICK");
        // alert(window.event.clientX)
        // IDIS = `${1}${col}`;
        // IDIS = window.event.clientX*window.event.clientY;

        // return   // for now disabling user click

        // ── Tutorial interaction locking ──
        if (this.isTutorialMode()) {
            const expected = this.getExpectedTutorialAction()
            // If expected is null (last step), bypass the lock and allow the click
            if (expected && expected.type !== 'CLICK_HEX') {
                return // Block: tutorial expects a different action right now
            }
        }

        if (dontTriggerClick) {
            dontTriggerClick = false
            return
        }
        var { logic } = this.props

        const { currentProgramGuide } = logic

        var todo = 'current'

        logic.insertState = false

        const { type } = drawing.board[row][col]

        if (type === 'blank' || type === 'hand' || type === 'highlighted_hand')
            todo = 'blank'

        if (todo === 'current') {
            logic.active = [row, col]

            drawing = ProgramToDrawing(
                undefined,
                logic.program,
                logic.end,
                logic.currentProgramGuide,
                logic.active,
                this.add,
                logic.insertState,
                this.insertNode,
                this.insertBtwnNode,
                this.deleteNode,
                this.click
            )

            var logicState = {}
            logicState['type'] = this.state.currentLogicScreen
            logicState['state'] = logic

            this.props.update(logic)

            // Tutorial auto-advance after clicking the insert point
            if (this.isTutorialMode()) {
                setTimeout(() => this.advanceTutorialStep(), 50)
            }
        } else if (todo === 'blank') {
            logic.active = [-1, -1]

            // Uncomment the following line to auto-minimize bottomPanel on blank space click
            // logic.bottomPanel = 'border';
            drawing = ProgramToDrawing(
                undefined,
                logic.program,
                logic.end,
                logic.currentProgramGuide,
                logic.active,
                this.add,
                logic.insertState,
                this.insertNode,
                this.insertBtwnNode,
                this.deleteNode
            )

            var logicState = {}
            logicState['type'] = this.state.currentLogicScreen
            logicState['state'] = logic

            this.props.update(logic)
        }
    }
    recurseAdd = (instructions, nesting, toPush) => {
        // alert("RECURSE_ADD");

        if (instructions.length !== 0) {
            if (nesting === 0) {
                instructions.push(toPush)
            } else {
                this.recurseAdd(
                    instructions[instructions.length - 1].subprogram,
                    nesting - 1,
                    toPush
                )
            }
        }
    }
    add = (type) => {
        // alert("ADD()");
        console.log('checking add', type)

        // ── Tutorial interaction locking ──
        let expected = null
        let _addSkipTwoSlides = false
        if (this.isTutorialMode()) {
            expected = this.getExpectedTutorialAction()
            const normalizedType = type
                ? TUTORIAL_BLOCK_TYPE_MAP[type] || type
                : null
            // Only truly intermediate UI-navigation types belong here.
            // Real block types (loop, condition, sensor, variable) that
            // directly add nodes must NOT be in this list — otherwise they
            // bypass the expected-type check.
            const SUBMENU_TYPES = ['action', 'decision', 'if']

            let isAllowed = false

            const isEndBlock = (t) =>
                typeof t === 'string' && t.startsWith('end_')

            if (
                expected?.type === 'ADD_BLOCK' &&
                (normalizedType === expected.expectedBlockType ||
                    (isEndBlock(normalizedType) &&
                        isEndBlock(expected.expectedBlockType)) ||
                    type == null ||
                    SUBMENU_TYPES.includes(type))
            ) {
                isAllowed = true
            } else if (
                expected?.type === 'INSERT_BLOCK' &&
                (normalizedType === expected.expectedBlockType ||
                    (isEndBlock(normalizedType) &&
                        isEndBlock(expected.expectedBlockType)) ||
                    type == null ||
                    SUBMENU_TYPES.includes(type))
            ) {
                isAllowed = true
            } else if (
                expected?.type === 'CLICK_HEX' &&
                (type == null || SUBMENU_TYPES.includes(type))
            ) {
                isAllowed = true
            }

            // Lookahead: Handle skipping pre-select and select-active if clicked directly
            if (
                !isAllowed &&
                expected?.type === 'CLICK_HEX' &&
                type != null &&
                !SUBMENU_TYPES.includes(type)
            ) {
                const { stepsSlideIndex, logicSteps, microSlides } = this.state
                if (microSlides && stepsSlideIndex + 1 < microSlides.length) {
                    const nextSlide = microSlides[stepsSlideIndex + 1]
                    if (
                        nextSlide &&
                        (nextSlide.phase === 'select_active' ||
                            nextSlide.phase === 'insert_choose')
                    ) {
                        const nextStep =
                            logicSteps.steps?.[nextSlide.codeStepIndex]
                        if (nextStep) {
                            const nextExpectedType =
                                TUTORIAL_BLOCK_TYPE_MAP[nextStep.blockType] ||
                                nextStep.blockType
                            if (
                                normalizedType === nextExpectedType ||
                                (isEndBlock(normalizedType) &&
                                    isEndBlock(nextExpectedType))
                            ) {
                                isAllowed = true
                                _addSkipTwoSlides = true
                            }
                        }
                    }
                }
            }

            if (!isAllowed) {
                return // Block
            }
        }

        if (type == 'repeat' || type == 'end') {
            this.setState({ readyForSimulation: type })
            sessionStorage.setItem('programEnd', type)
        }

        if (dontTriggerClick) {
            dontTriggerClick = false
            return
        }

        var { logic } = this.props

        logic.active = [-1, -1]

        // console.log("logic.program new", logic.program, type)

        if (
            type === 'end_variable' ||
            type === 'end_sensor' ||
            type === 'end_condition' ||
            type === 'end_if' ||
            type === 'end_loop'
            // ||
            // type === "repeat"
        )
            logic.currentProgramGuide--
        else {
            var toPush = { type: type, state: {} }

            if (
                type === 'variable' ||
                type === 'sensor' ||
                type === 'condition' ||
                type === 'loop'
            )
                toPush.subprogram = []
            this.recurseAdd(logic.program, logic.currentProgramGuide, toPush)
            if (
                type === 'variable' ||
                type === 'sensor' ||
                type === 'condition' ||
                type === 'loop'
            )
                logic.currentProgramGuide++
        }

        drawing = ProgramToDrawing(
            type,
            logic.program,
            logic.end,
            logic.currentProgramGuide,
            logic.active,
            this.add
        )
        var logicState = {}
        logicState['type'] = this.state.currentLogicScreen
        logicState['state'] = logic

        this.props.update(logic)

        saveToLocalStorage()

        // Force re-render after adding
        this.forceUpdate()

        // ── Tutorial auto-advance ──
        if (this.isTutorialMode()) {
            const SUBMENU_TYPES = ['action', 'decision', 'if']
            if (_addSkipTwoSlides) {
                // User clicked a block type directly at pre_select
                // (e.g. end_condition). Advance twice past both
                // pre_select and select_active.
                setTimeout(() => {
                    this.advanceTutorialStep()
                    setTimeout(() => this.advanceTutorialStep(), 50)
                }, 50)
            } else if (expected?.type === 'CLICK_HEX' && type == null) {
                setTimeout(() => this.advanceTutorialStep(), 50)
            } else if (
                (expected?.type === 'INSERT_BLOCK' ||
                    expected?.type === 'ADD_BLOCK') &&
                type !== null &&
                !SUBMENU_TYPES.includes(type)
            ) {
                setTimeout(() => this.advanceTutorialStep(), 50)
            }
        }

        // Check for tutorial deviation after user adds a node
        setTimeout(() => {
            this.checkTutorialDeviation()
        }, 100)
    }

    /////////////// HUMANOID FUNCTION /////////////
    addUniqueId = (program, type) => {
        if (
            ['Ace', 'Roboki', 'Atr', 'Toki', 'Poki', 'Moki'].includes(
                sessionStorage.getItem('connectedDevice')
            )
        )
            return

        let newNodeId = parseInt(sessionStorage.getItem('nodeCounter')) || 0
        newNodeId += 1
        sessionStorage.setItem('nodeCounter', newNodeId)

        const humanoidPortData = JSON.parse(
            sessionStorage.getItem('humanoidPortData') || ''
        )
        const humanoidProgramData = JSON.parse(
            sessionStorage.getItem('humanoidProgramData')
        )

        let stateData = {}
        Object.entries(humanoidPortData).map((port) => {
            stateData[port[0]] = {
                name: humanoidPortData[port[0]].name,
                value: humanoidPortData[port[0]].value,
                isActionEnabled: humanoidPortData[port[0]].isActionEnabled,
                isLiveBtnActive: false,
            }
            // if([''].includes(port[0]))
        })

        //add the isRandomActionSelected in actionGroup state
        if (
            ['Humanoid', 'Hexapod'].includes(
                sessionStorage.getItem('connectedDevice')
            )
        ) {
            stateData['4a'].isRandomActionSelected = false
        }

        let node = {
            id: newNodeId,
            type: type,
            state: stateData,
        }
        if (type == 'condition') node.state = { port: '', value: 0, value1: 0 }

        sessionStorage.setItem(
            'humanoidProgramData',
            JSON.stringify({ ...humanoidProgramData, [node.id]: node })
        )

        this.findAndAttachNewId(program, newNodeId)
    }

    /////////////// HUMANOID FUNCTION /////////////
    findAndAttachNewId = (program, newNodeId) => {
        for (let node = 0; node < program.length; node++) {
            // newNodeId is attached to that node which doesn't have an id yet.
            // At any point, only the newly created node will not have an id and that's how we find the newNode.
            // This nodeId is also the key for each object in *humanoidProgramData*.
            if (
                program[node].nodeId === undefined &&
                (program[node].type === 'hardware' ||
                    program[node].type === 'condition' ||
                    program[node].type === 'sensor')
            ) {
                program[node].nodeId = newNodeId
                break
            }
            if (
                program[node].type === 'condition' ||
                program[node].type === 'sensor' ||
                program[node].type === 'loop'
            ) {
                this.findAndAttachNewId(program[node].subprogram, newNodeId)
            }
        }
    }

    insertNode = (type) => {
        // for(let n = 0; n<drawing.activeParentRef.slice(drawing.activeIndex, drawing.activeParentRef.length).length; n++){
        //   drawing.activeParentRef[n].id= JSON.stringify(Number(drawing.activeParentRef[n].id) + 1)
        // }

        // ── Tutorial interaction locking ──
        let expected = null
        if (this.isTutorialMode()) {
            expected = this.getExpectedTutorialAction()
            const normalizedType = type
                ? TUTORIAL_BLOCK_TYPE_MAP[type] || type
                : null
            const SUBMENU_TYPES = ['action', 'decision', 'if']

            let isAllowed = false

            const isEndBlock = (t) =>
                typeof t === 'string' && t.startsWith('end_')

            if (
                expected?.type === 'ADD_BLOCK' &&
                (normalizedType === expected.expectedBlockType ||
                    (isEndBlock(normalizedType) &&
                        isEndBlock(expected.expectedBlockType)) ||
                    type == null ||
                    SUBMENU_TYPES.includes(type))
            ) {
                isAllowed = true
            } else if (
                expected?.type === 'INSERT_BLOCK' &&
                (normalizedType === expected.expectedBlockType ||
                    (isEndBlock(normalizedType) &&
                        isEndBlock(expected.expectedBlockType)) ||
                    type == null ||
                    SUBMENU_TYPES.includes(type))
            ) {
                isAllowed = true
            } else if (
                expected?.type === 'CLICK_HEX' &&
                (type == null || SUBMENU_TYPES.includes(type))
            ) {
                isAllowed = true
            }

            if (!isAllowed) {
                return // Block
            }
        }

        num++

        var { logic } = this.props

        // if (!logic.insertState) {
        //   logic.insertState = true;
        // } //removed by gautam to change to single click
        if (type == null) {
            logic.insertState = true
        } else {
            // this condition is for the  render the bolck wait click it action and then wait hadrware panke will open
            if (type != 'action') {
                logic.insertState = false
                var temp = drawing.activeParentRef[drawing.activeIndex]

                // HERE I AM STOPING TO ADD THE ACTION on HEXBOARD

                var toPush = { type: type, state: {}, id: IDIS }
                if (
                    type === 'end_variable' ||
                    type === 'end_sensor' ||
                    type === 'end_condition' ||
                    type === 'end_if' ||
                    type === 'end_loop'
                    // ||
                    // type === "repeat"
                ) {
                    logic.currentProgramGuide--
                }
                if (
                    type === 'variable' ||
                    type === 'condition' ||
                    type === 'sensor' ||
                    type === 'loop' ||
                    type === 'if'
                ) {
                    logic.currentProgramGuide++
                    toPush.subprogram = []
                }
                drawing.activeParentRef[drawing.activeIndex] = toPush

                for (
                    let i = drawing.activeIndex + 1;
                    i < drawing.activeParentRef.length;
                    i++
                ) {
                    var temp2 = drawing.activeParentRef[i]
                    drawing.activeParentRef[i] = temp
                    temp = temp2
                }
                if (temp) drawing.activeParentRef.push(temp)
                logic.active = [-1, -1]

                logic.program.map((i, id) => {
                    i.id = `${1}${id}`
                })

                /////////////////////////////////////////////
                ///////////// Humanoid code /////////////////
                if (type === 'hardware' || type === 'condition') {
                    this.addUniqueId(logic.program, type)
                }
                /////////// Humanoid code ends //////////////
                /////////////////////////////////////////////
            }
        }

        drawing = ProgramToDrawing(
            type,
            logic.program,
            logic.end,
            logic.currentProgramGuide,
            logic.active,
            this.add,
            logic.insertState,
            this.insertNode,
            this.insertBtwnNode,
            this.deleteNode
        )

        // ── Tutorial auto-advance ──
        if (this.isTutorialMode()) {
            const SUBMENU_TYPES = ['action', 'decision', 'if']
            if (expected?.type === 'CLICK_HEX' && type == null) {
                setTimeout(() => this.advanceTutorialStep(), 50)
            } else if (
                (expected?.type === 'INSERT_BLOCK' ||
                    expected?.type === 'ADD_BLOCK') &&
                type !== null &&
                !SUBMENU_TYPES.includes(type)
            ) {
                setTimeout(() => this.advanceTutorialStep(), 50)
            }
        }

        var logicState = {}
        logicState['type'] = this.state.currentLogicScreen
        logicState['state'] = logic

        this.props.update(logic)
        saveToLocalStorage()
    }

    insertBtwnNode = (type) => {
        // for(let n = 0; n<drawing.activeParentRef.slice(drawing.activeIndex, drawing.activeParentRef.length).length; n++){
        //   drawing.activeParentRef[n].id= JSON.stringify(Number(drawing.activeParentRef[n].id) + 1)
        // }

        // ── Tutorial interaction locking ──
        let expected = null
        if (this.isTutorialMode()) {
            expected = this.getExpectedTutorialAction()
            const normalizedType = type
                ? TUTORIAL_BLOCK_TYPE_MAP[type] || type
                : null
            const SUBMENU_TYPES = ['action', 'decision', 'if']

            let isAllowed = false

            const isEndBlock = (t) =>
                typeof t === 'string' && t.startsWith('end_')

            if (
                expected?.type === 'ADD_BLOCK' &&
                (normalizedType === expected.expectedBlockType ||
                    (isEndBlock(normalizedType) &&
                        isEndBlock(expected.expectedBlockType)) ||
                    type == null ||
                    SUBMENU_TYPES.includes(type))
            ) {
                isAllowed = true
            } else if (
                expected?.type === 'INSERT_BLOCK' &&
                (normalizedType === expected.expectedBlockType ||
                    (isEndBlock(normalizedType) &&
                        isEndBlock(expected.expectedBlockType)) ||
                    type == null ||
                    SUBMENU_TYPES.includes(type))
            ) {
                isAllowed = true
            } else if (
                expected?.type === 'CLICK_HEX' &&
                (type == null || SUBMENU_TYPES.includes(type))
            ) {
                isAllowed = true
            }

            if (!isAllowed) {
                return // Block
            }
        }

        num++

        var { logic } = this.props
        console.log('checkingvalues', type)
        // if (!logic.insertState) {
        //   logic.insertState = true;
        // } //removed by gautam to change to single click
        if (type == null) {
            logic.insertState = true
        } else {
            // this condition is for the  render the bolck wait click it action and then wait hadrware panke will open
            if (type != 'action') {
                logic.insertState = false
                var temp = drawing.activeParentRef[drawing.activeIndex]

                // HERE I AM STOPING TO ADD THE ACTION on HEXBOARD

                var toPush = { type: type, state: {}, id: IDIS, newId: num }

                if (
                    type === 'variable' ||
                    type === 'condition' ||
                    type === 'sensor' ||
                    type === 'loop' ||
                    type === 'if'
                ) {
                    // logic.currentProgramGuide++;
                    toPush.subprogram = []
                }
                drawing.activeParentRef[drawing.activeIndex] = toPush

                for (
                    let i = drawing.activeIndex + 1;
                    i < drawing.activeParentRef.length;
                    i++
                ) {
                    var temp2 = drawing.activeParentRef[i]
                    drawing.activeParentRef[i] = temp
                    temp = temp2
                }
                if (temp) drawing.activeParentRef.push(temp)
                logic.active = [-1, -1]

                logic.program.map((i, id) => {
                    i.id = `${1}${id}`
                })

                /////////// Humanoid code ////////////////////
                if (type === 'hardware' || type === 'condition') {
                    this.addUniqueId(logic.program, type)
                }
            }
        }

        drawing = ProgramToDrawing(
            type,
            logic.program,
            logic.end,
            logic.currentProgramGuide,
            logic.active,
            this.add,
            logic.insertState,
            this.insertNode,
            this.insertBtwnNode,
            this.deleteNode
        )

        // ── Tutorial auto-advance ──
        if (this.isTutorialMode()) {
            const SUBMENU_TYPES = ['action', 'decision', 'if']
            if (expected?.type === 'CLICK_HEX' && type == null) {
                setTimeout(() => this.advanceTutorialStep(), 50)
            } else if (
                (expected?.type === 'INSERT_BLOCK' ||
                    expected?.type === 'ADD_BLOCK') &&
                type !== null &&
                !SUBMENU_TYPES.includes(type)
            ) {
                setTimeout(() => this.advanceTutorialStep(), 50)
            }
        }

        var logicState = {}
        logicState['type'] = this.state.currentLogicScreen
        logicState['state'] = logic

        this.props.update(logic)
        saveToLocalStorage()
    }

    deleteNode = () => {
        // ── Tutorial interaction locking ──
        if (this.isTutorialMode()) {
            const expected = this.getExpectedTutorialAction()
            if (!expected || expected.type !== 'DELETE_BLOCK') {
                return // Block
            }
        }

        var { logic } = this.props

        if (
            drawing.activeRef.type == 'repeat' ||
            drawing.activeRef.type == 'end'
        ) {
            sessionStorage.removeItem('PET')
            sessionStorage.removeItem('EndSwitch')
        }

        if (
            drawing.activeParentRef.length - 1 == drawing.activeIndex &&
            (drawing.activeRef.type === 'variable' ||
                drawing.activeRef.type === 'sensor' ||
                drawing.activeRef.type === 'condition' ||
                drawing.activeRef.type === 'loop')
        ) {
            let currentProgramGuide = 0,
                temp = logic.program
            while (
                temp != drawing.activeParentRef &&
                currentProgramGuide < logic.currentProgramGuide
            ) {
                temp = temp[temp.length - 1].subprogram
                currentProgramGuide++
            }
            if (currentProgramGuide < logic.currentProgramGuide)
                logic.currentProgramGuide = currentProgramGuide
        }

        if (drawing.activeRef.type === 'end') {
            logic.currentProgramGuide = 0
        }

        drawing.activeParentRef.splice(drawing.activeIndex, 1)
        logic.active = [-1, -1]

        drawing = ProgramToDrawing(
            undefined,
            logic.program,
            logic.end,
            logic.currentProgramGuide,
            logic.active,
            this.add,
            logic.insertState,
            this.insertNode,
            this.insertBtwnNode,
            this.deleteNode
        )

        // ── Tutorial auto-advance ──
        if (this.isTutorialMode()) {
            setTimeout(() => this.advanceTutorialStep(), 50)
        }

        var logicState = {}
        logicState['type'] = this.state.currentLogicScreen
        logicState['state'] = logic

        this.props.update(logic)
        saveToLocalStorage()

        setTimeout(() => {
            this.checkTutorialDeviation()
        }, 100)
    }

    toggleBottomPanel = async (e, nodeId) => {
        // return   // for now disabling user click

        // ── Tutorial interaction locking ──
        let _tutorialExpected = null
        if (this.isTutorialMode()) {
            _tutorialExpected = this.getExpectedTutorialAction()

            // Only enforce lock if there is a specific action expected
            if (_tutorialExpected) {
                const panelIsOpen = this.props.logic.bottomPanel === 'show'

                if (_tutorialExpected.type === 'OPEN_PANEL' && !panelIsOpen) {
                    // Allow — opening the panel as expected
                } else if (
                    _tutorialExpected.type === 'CLOSE_PANEL' &&
                    panelIsOpen
                ) {
                    // Allow — closing the panel as expected
                } else {
                    return // Block: panel can only be closed when tutorial expects CLOSE_PANEL
                }
            }
        }

        //if click on live buttn that time you can not close the panel, because the zing and hexapod v1,
        //sending the setting bytes, after 2.3 sec again we send the bytes, other waise it does not worke
        if (this.props.concept?.disableAfterSettingByt) {
            return
        }

        if (sessionStorage.getItem('isReadingZingPA') == 'true') {
            sessionStorage.setItem('isReadingZingPA', false)
            continousPABytesReadToggle(
                null,
                null,
                this.props.webSerial.port,
                null,
                'OFF'
            )
        }

        var { logic, logicEditor, update } = this.props
        var endchek = true
        console.log('endchek', e, nodeId)
        try {
            if (e.includes('end_')) {
                endchek = false
            }
        } catch (error) {}

        if (endchek) {
            if (logic.bottomPanel === 'show') {
                logic.bottomPanel = 'border'
                // console.log('VVVVVVVVVVVV1111', drawing.activeRef.type)
                //disabled all live button when close the action panel
                if (drawing.activeRef.type === 'hardware') {
                    let newState = drawing.activeRef.state
                    let isDisableCustomactionButton = false

                    //send the PLAY bytes to stop the all live  output, if live output enable
                    if (
                        Object.keys(newState).some((objKey) => {
                            if (objKey.includes('liveBtn')) {
                                return newState[objKey]
                            } else return false
                        })
                    ) {
                        const connectedDevice =
                            sessionStorage.getItem('connectedDevice')
                        const deviceVersion =
                            sessionStorage.getItem('deviceVersion')

                        let sendStopBytes = stopByteCondition({
                            connectedDevice,
                            deviceVersion,
                        })

                        setTimeout(() => {
                            this.props.worker.postMessage({
                                type: 'writeArray',
                                value: sendStopBytes,
                            })
                        }, 100)
                    }

                    //for zing klaw hexapod desabled the liveBtn
                    if (
                        ['Klaw', 'Humanoid', 'Hexapod'].includes(
                            sessionStorage.getItem('connectedDevice')
                        )
                    ) {
                        let humanoidProgramData = {}
                        let humanoidProgramDataId = drawing.activeRef.nodeId
                        try {
                            humanoidProgramData = JSON.parse(
                                sessionStorage.getItem('humanoidProgramData')
                            )
                        } catch (e) {
                            console.log('ERROR', e)
                        }
                        let humanoidProgramDataState =
                            humanoidProgramData[humanoidProgramDataId].state

                        if (
                            humanoidProgramDataState?.['4a']?.value === '74' &&
                            !humanoidProgramDataState?.['4a']
                                ?.isRandomActionSelected
                        ) {
                            humanoidProgramDataState['4a'].value = 0
                            isDisableCustomactionButton = true
                        }
                        for (const objKey of Object.keys(
                            humanoidProgramDataState
                        )) {
                            if (
                                humanoidProgramDataState[objKey]
                                    ?.isLiveBtnActive
                            ) {
                                humanoidProgramDataState[
                                    objKey
                                ].isLiveBtnActive = false
                            }

                            //set the defolt postion for serial servo zing and hexapod
                            if (
                                humanoidProgramDataState[objKey]?.isLiveSActive
                            ) {
                                let PORTDATAKey = generateDeviceDataKey(
                                    sessionStorage.getItem('connectedDevice'),
                                    sessionStorage.getItem('deviceVersion')
                                )
                                let defaultServoValue =
                                    PORTDATA[PORTDATAKey]?.[objKey]?.value
                                if (defaultServoValue) {
                                    let servoFeedbackBytes = [
                                        'S'.charCodeAt(0),
                                        'M'.charCodeAt(0),
                                        parseInt(objKey - 4),
                                    ]
                                    let MSBLSB =
                                        decimalToMSBLSB(defaultServoValue)
                                    servoFeedbackBytes.push(
                                        MSBLSB[0],
                                        MSBLSB[1]
                                    )

                                    this.props.worker.postMessage({
                                        type: 'writeArray',
                                        value: servoFeedbackBytes,
                                    })
                                }
                                humanoidProgramDataState[objKey].isLiveSActive =
                                    false

                                await new Promise((reslove) =>
                                    setTimeout(reslove, 100)
                                )
                            }
                        }

                        sessionStorage.setItem(
                            'humanoidProgramData',
                            JSON.stringify(humanoidProgramData)
                        )

                        //--------------------------------------------
                        const updateLogicProgram = (program) => {
                            for (let node = 0; node < program.length; node++) {
                                if (
                                    program[node].nodeId ===
                                    drawing.activeRef.nodeId
                                ) {
                                    //set false custom action button in redux
                                    if (isDisableCustomactionButton) {
                                        program[node].state.assignCustomAction =
                                            false
                                    }

                                    // program[node].state = newState
                                    Object.keys(program[node].state).map(
                                        (objKey) => {
                                            if (objKey.includes('liveBtn')) {
                                                program[node].state[objKey] =
                                                    false
                                            }
                                        }
                                    )
                                    break
                                }
                                if (
                                    program[node].type === 'condition' ||
                                    program[node].type === 'sensor' ||
                                    program[node].type === 'loop'
                                ) {
                                    updateLogicProgram(program[node].subprogram)
                                }
                            }
                        }
                        updateLogicProgram(logic.program)
                        ///-------------
                    } else {
                        Object.keys(newState).map((objKey) => {
                            if (objKey.includes('liveBtn')) {
                                newState[objKey] = false
                            }
                        })
                    }

                    // drawing.activeRef.state = newState
                }
            } else logic.bottomPanel = 'show'
        }

        var logicState = {}
        logicState['type'] = this.state.currentLogicScreen
        var logicToBeChanged
        // if (this.state.currentLogicScreen == "hexa") {
        logicToBeChanged = logic
        // } else if (this.state.currentLogicScreen == "flow") {
        //   logicToBeChanged = logicNew;
        // }
        // else if (this.state.currentLogicScreen == "python") {
        //   logicToBeChanged = pythonEditor;
        // } else {
        //   logicToBeChanged = logicEditor;
        // }

        logicState['state'] = logicToBeChanged

        this.props.update(logic)

        // ── Tutorial auto-advance after panel toggle ──
        if (_tutorialExpected) {
            const panelNowOpen = logic.bottomPanel === 'show'
            const panelNowClosed = logic.bottomPanel === 'border'
            if (
                (_tutorialExpected.type === 'OPEN_PANEL' && panelNowOpen) ||
                (_tutorialExpected.type === 'CLOSE_PANEL' && panelNowClosed)
            ) {
                setTimeout(() => this.advanceTutorialStep(), 50)
            }
        }
    }
    /* 
    function to recursively delete start keys which are false and are 
    present in other nodes of the program.
  */
    bottomPanelDelete = (key) => {
        var { logic } = this.props
        var search = key
        function recursiveDeleteFromObject(search, OBJ) {
            for (var key in OBJ) {
                if (!(key == search) && typeof OBJ[key] === 'object') {
                    recursiveDeleteFromObject(search, OBJ[key])
                } else {
                    if (key == search) {
                        delete OBJ[key]
                    }
                }
            }
            return OBJ
        }
        function recursiveDeleteFromArrayObject(search, Arr_OBJ) {
            for (var key in Arr_OBJ) {
                Arr_OBJ[key] = recursiveDeleteFromObject(search, Arr_OBJ[key])
            }
            return Arr_OBJ
        }
        var result = recursiveDeleteFromArrayObject(search, logic.program)
        logic.program = result
        var logicState = {}
        logicState['type'] = this.state.currentLogicScreen
        logicState['state'] = logic

        this.props.update(logic)
        saveToLocalStorage()
    }

    bottomPanelChange = (state, type) => {
        // ── Tutorial interaction locking ──
        let _prevExpectedKeyValue = undefined
        if (this.isTutorialMode()) {
            const expected = this.getExpectedTutorialAction()
            if (!expected) return

            // Snapshot the current value of the key we care about
            if (expected.hardwareKey) {
                const currentState = drawing.activeRef?.state
                if (typeof currentState === 'object' && currentState !== null) {
                    _prevExpectedKeyValue = currentState[expected.hardwareKey]
                } else if (typeof currentState === 'string') {
                    _prevExpectedKeyValue = currentState
                }
            }

            // Key-level locking: only allow changes to the expected hardwareKey.
            if (
                (expected.type === 'PANEL_CHANGE' ||
                    expected.type === 'SELECT_READ_SOURCE' ||
                    expected.type === 'READ_SENSOR') &&
                typeof state === 'object' &&
                state !== null &&
                expected.hardwareKey
            ) {
                const currentState = drawing.activeRef.state
                if (typeof currentState === 'object' && currentState !== null) {
                    for (const key of Object.keys(state)) {
                        // Do not revert read keys if user happens to touch them
                        if (
                            key !== expected.hardwareKey &&
                            state[key] !== currentState[key] &&
                            key !== '_readSource' &&
                            key !== '_readAction'
                        ) {
                            state[key] = currentState[key]
                        }
                    }
                }
            } else if (
                expected.type !== 'PANEL_CHANGE' &&
                expected.type !== 'SELECT_READ_SOURCE' &&
                expected.type !== 'READ_SENSOR'
            ) {
                return // Block entirely
            }
        }

        var { logic } = this.props

        // ── Fix 2: immutable state hand-off ──
        // Never store or forward the caller's object by reference. Cloning here
        // guarantees every change produces a FRESH state reference, so React and
        // react-redux reliably detect the change and the BottomPanel/Slider tree
        // can't render a stale (previous-block) value mid-interaction. Reassign
        // the param so all downstream logic (tutorial matching, captureValue
        // Changed, the re-assignments below) operates on the clone.
        const nextState =
            typeof state === 'object' && state !== null ? { ...state } : state
        state = nextState

        if (type) {
            drawing.activeRef.type = type
        }

        drawing.activeRef.state = state
        if (state == 'end') {
            drawing.activeRef.type = 'end'
            sessionStorage.setItem('EndSwitch', 'end')
        }
        if (state == 'repeat') {
            drawing.activeRef.type = 'repeat'
            sessionStorage.removeItem('EndSwitch')
        }

        // ★ Capture value changes (debounced via functional setState)
        if (typeof this.captureValueChanged === 'function') {
            this.captureValueChanged(state)
        }

        if (drawing.activeRef.type === 'end')
            console.log('bottomPanelChange end')

        drawing = ProgramToDrawing(
            undefined,
            logic.program,
            logic.end,
            logic.currentProgramGuide,
            logic.active,
            this.add
        )

        // ── Tutorial auto-advance ──
        if (this.isTutorialMode()) {
            const expected = this.getExpectedTutorialAction()
            let matched = false
            let valueActuallyChanged = false

            if (expected?.type === 'SELECT_READ_SOURCE') {
                if (state && state._readSource === expected.expectedValue) {
                    matched = true
                    valueActuallyChanged =
                        String(_prevExpectedKeyValue) !==
                        String(state._readSource)
                }
            } else if (expected?.type === 'READ_SENSOR') {
                if (state && state._readAction === true) {
                    matched = true
                    valueActuallyChanged = true // Button clicks are always a "change"

                    // 🔴 CRITICAL FIX: Reset the click state instantly so it doesn't cause an infinite loop!
                    state._readAction = false
                    drawing.activeRef.state = state
                }
            } else if (expected?.type === 'PANEL_CHANGE') {
                if (typeof state === 'string') {
                    if (
                        expected.hardwareKey === 'state' &&
                        state == expected.expectedValue
                    ) {
                        matched = true
                        valueActuallyChanged =
                            String(_prevExpectedKeyValue) !== String(state)
                    }
                } else if (typeof state === 'object' && state !== null) {
                    if (
                        String(state[expected.hardwareKey]) ===
                        String(expected.expectedValue)
                    ) {
                        matched = true
                        valueActuallyChanged =
                            String(_prevExpectedKeyValue) !==
                            String(state[expected.hardwareKey])
                    }
                }
            }

            if (matched && valueActuallyChanged) {
                if (
                    typeof state === 'object' &&
                    state !== null &&
                    expected.hardwareKey &&
                    expected.type !== 'READ_SENSOR'
                ) {
                    state[expected.hardwareKey] = expected.expectedValue
                    drawing.activeRef.state = state
                }

                setTimeout(() => {
                    if (this._isMounted) this.advanceTutorialStep()
                }, 50)
            }
        }

        var logicState = {}
        logicState['type'] = this.state.currentLogicScreen
        logicState['state'] = logic
        // Fix 2: pass a fresh top-level reference so connect can't shallow-equal
        // this away as "unchanged" after an in-place mutation.
        this.props.update({ ...logic })
        saveToLocalStorage()

        // Force React to re-render the UI and BottomPanel instantly
        this.forceUpdate()

        // Check for tutorial deviation after user makes changes
        setTimeout(() => {
            if (this._isMounted) this.checkTutorialDeviation()
        }, 100)
    }

    handleBottomPanelClick = () => {
        var { logic } = this.props
        if (logic.bottomPanel === 'show') {
            logic.bottomPanel = 'border'
            dontTriggerClick = true
        }
        var logicState = {}
        logicState['type'] = this.state.currentLogicScreen
        logicState['state'] = logic

        this.props.update(logic)
    }

    seperateClicked = () => {
        // $(document).ready(function =()=>{
        //   $(".hide").click(function =()=>{
        //     $("p").hide();
        //   });
        //   $(".show").click(function =()=>{
        //     $("p").show();
        //   });
        // });
    }

    clickmeUp = () => {
        // Tutorial locking: block if not expected
        if (this.isTutorialMode()) {
            const expected = this.getExpectedTutorialAction()
            if (!expected || expected.type !== 'OPEN_PANEL') return
        }
        var { logic } = this.props
        if (logic.bottomPanel != 'show') logic.bottomPanel = 'show'
        var logicState = {}
        logicState['type'] = this.state.currentLogicScreen
        logicState['state'] = logic

        this.props.update(logic)
    }
    clickmeDown = () => {
        // Tutorial locking: block if not expected
        if (this.isTutorialMode()) {
            const expected = this.getExpectedTutorialAction()
            if (!expected || expected.type !== 'CLOSE_PANEL') return
        }
        var { logic } = this.props
        if (logic.bottomPanel === 'show') logic.bottomPanel = 'border'
        var logicState = {}
        logicState['type'] = this.state.currentLogicScreen
        logicState['state'] = logic

        this.props.update(logic)
    }

    setCurrentNode(current, index) {
        this.setState({ currentNode: current, currentNodeIndex: index })
    }

    showSetting = () => {
        document.getElementById('divH').style.display = 'inline'
    }
    closeSetting = () => {
        document.getElementById('divH').style.display = 'none'
        document.getElementById('divH1').style.display = 'none'
    }
    showConverter = () => {
        document.getElementById('divH1').style.display = 'block'
    }

    Save = () => {
        // console.log("SAVE==>");
    }

    close = () => {
        this.setState({ modalIsOpen: false })
    }

    closeReconnectModal = () => {
        this.setState({ showReconnectModal: false, reconnectStatus: null })
    }

    handleInlineConnect = async () => {
        this.setState({ reconnectStatus: 'scanning' })
        try {
            const res = await connectSerialDeviceInitial(
                { isAutomatic: false },
                this.props.worker,
                this.props.socketData
            )
            if (res !== undefined && res.isPortOpen) {
                const deviceVersion = sessionStorage.getItem('deviceVersion')
                const connectedDevice = sessionStorage.getItem('connectedDevice')
                this.props.deviceDetails({ connectedDevice, deviceVersion })
                this.props.webSerialConnect({ port: res.port })
                this.props.deviceMismatch({
                    deviceMismatched: {},
                    isMemoryPresent: res.isMemoryPresent,
                    isArmError: res.isArmError,
                    is2In1Sensor: res.is2In1Sensor,
                })
                sessionStorage.setItem('manualConnection', false)
                this.setState({ showReconnectModal: false, reconnectStatus: null })
            } else if (res && !res.isPortOpen) {

                this.setState({ reconnectStatus: 'mismatch' })
            } else {
                // User cancelled the browser USB picker
                this.setState({ reconnectStatus: null })
            }
        } catch (e) {
            this.setState({ reconnectStatus: null })
        }
    }

    closeUpload = () => {
        this.setState({ uploadOpen: false })
    }
    closeUsb = () => {
        this.setState({ usbOpen: false })
    }
    closeUploadSucess = () => {
        this.setState({ uploadSucessError: { isShow: false, message: '' } })
    }
    check = () => {
        var program = JSON.parse(sessionStorage.getItem('logicTwo')).program
        var end = JSON.parse(sessionStorage.getItem('logicTwo')).end
        var upldbtn = document.getElementById('uploadLogicscrn')
        upldbtn.style.pointerEvents = 'none'
        upldbtn.style.cursor = 'not-allowed'

        this.setState({ uploadOpen: true })
        setTimeout(() => {
            upldbtn.style.cursor = 'pointer'

            upldbtn.style.pointerEvents = 'all'

            this.setState({ uploadOpen: false })
        }, 5000)

        //var socket = socketIOClient("http://localhost:3008");
        if (localStorage.getItem('programMode') == 'learn') {
            // socket.emit("/checkLogic", program, end, "Final");
            // socket.on("/logicResult", (data) => {
            //   if (!data) {
            //     this.setState({ modalIsOpen: true });
            //     return true;
            //   } else {
            //     var params = {
            //       screen: "hexa",
            //       logic: this.props.logic,
            //       components: this.props.assembly.PortConnections,
            //     };
            //     var Peripherial = JSON.parse(localStorage.getItem("Bluetooth"));
            //     // console.log("this.props.history DONE LOGIC", Peripherial[0]["mac"])
            //     if (Peripherial) {
            //       socket.emit("/upload", { code: params }, Peripherial[0]["mac"]);
            //     } else {
            //       socket.emit("/upload", { code: params });
            //     }
            //     socket.on("_upload", (data) => {
            //       // this.setState({ modalIsOpen: true })
            //     });
            //     return false;
            //     // this.props.history.push("/Learn")
            //   }
            // });
        } else {
            var params = {
                screen: 'hexa',
                logic: this.props.logic,
                components: this.props.assembly.PortConnections,
            }
            var Peripherial = JSON.parse(localStorage.getItem('Bluetooth'))
            // console.log("this.props.history DONE LOGIC", Peripherial[0]["mac"])

            // if (Peripherial) {
            //   socket.emit("/upload", { code: params }, Peripherial[0]["mac"]);
            // } else {
            //   socket.emit("/upload", { code: params });
            // }

            // socket.on("_upload", (data) => {
            //   // this.setState({ modalIsOpen: true })
            // });
            return false
            // this.props.history.push("/Learn")
        }
    }
    tutor = () => {
        this.props.history.push('/saveTutorials')
    }
    hexTypeCheck = (value) => {
        this.setState({ hexType: value })
    }
    if = (value) => {
        return (
            <div>
                Click on the hand hex and click on action hex ,double click the
                action hex and select {value.type}{' '}
                {
                    ((
                        <div>
                            {' '}
                            Set{' '}
                            {Object.entries(value.state).map(([key, value]) => {
                                return (
                                    <span>
                                        {' '}
                                        {key} {value}
                                    </span>
                                )
                            })}
                        </div>
                    ),
                    (
                        <div>
                            {' '}
                            Down to {value.type}{' '}
                            {value.subprogram
                                ? value.subprogram.map((value, index) => {
                                      return value.type == 'hardware' ||
                                          value.type == 'variable' ||
                                          value.type == 'wait'
                                          ? this.output(value)
                                          : value.type == 'sensor' ||
                                              value.type == 'variable'
                                            ? this.if(value)
                                            : ''
                                      // return <div>{index}{value.type}</div>
                                  })
                                : ''}
                        </div>
                    ))
                }
            </div>
        )
    }
    output = (value) => {
        var hardware = []
        var keyValueArray = []
        var keyTypeArray = []
        var keyValue
        var keyType
        if (value.type == 'hardware') {
            hardware.push('Click on the hand icon and select Action ')
            hardware.push('Double Click and select hardware ')
            Object.entries(value.state).map(([key, value]) => {
                // return (<span> {key} {value}</span>)
                // var key1 = key[
                // var value1 = key["value"]
                if (key.includes('assign')) {
                    keyType = key.split('gn')
                    keyTypeArray.push(keyType[1])
                }

                if (key.includes('value')) {
                    keyValue = key.split('ue')
                }

                for (let i = 0; i < keyTypeArray.length; i++) {
                    if (keyValue) {
                        if (keyValue[1] == keyTypeArray[i]) {
                            keyValueArray.push([keyTypeArray[i] + ':' + value])
                        }
                    }
                }

                hardware.push('set ' + key + ' to ' + value)
            })
        }

        return (
            <div>
                Click on the hand hex and click on action hex ,double click the
                action hex and select {value.type}{' '}
                {
                    <div>
                        {' '}
                        Set{' '}
                        {Object.entries(value.state).map(([key, value]) => {
                            return (
                                <span>
                                    {' '}
                                    {key} {value}
                                </span>
                            )
                        })}
                    </div>
                }
            </div>
        )
    }

    checkForSimulation = () => {
        // let {bottomPanel} = this.props.logic
        // if(bottomPanel){
        //   return;
        // }
        if (sessionStorage.getItem('PET') == null) {
            this.setState({ checkEndProgram: true })
            return
        }
        localStorage.setItem('recoveryData', JSON.stringify(sessionStorage))
        if (this.state.readyForSimulation === 'repeat') {
            this.props.history.push('/simulate')
            window.location.reload(false)
        } else {
            this.setState({ checkEndProgram: true })
        }
    }
    closecheckEndProgram = () => {
        this.setState({ checkEndProgram: false })
    }
    closeExcitDataLimitPopup = () => {
        this.setState({ excitDataLimitPopup: false })
    }

    getStepsSlideCount = (stepsData) => {
        if (!stepsData) return 0
        // v2.0 format: use pre-computed microSlides
        if (stepsData.version === '2.0' && stepsData.steps) {
            const { microSlides } = this.state
            return microSlides ? microSlides.length : 0
        }
        // v1.0 legacy format
        const stepCount =
            Number(stepsData.totalSteps || stepsData.steps?.length || 0) || 0
        return stepCount
    }

    // ITS =(e) => {
    //   alert(e)
    // }
    async writePort(data) {
        try {
            const filters = [{ usbVendorId: 0x1a86, usbProductId: 0x7523 }]
            const ports = await navigator.serial.getPorts({ filters })
            console.log('portsss', ports)

            console.log('portsss', ports[0].writable, this.props.webSerial.port)
            // const outputStream = ports[0].writable,
            if (this.props.webSerial.port !== undefined) {
                const writer = this.props.webSerial.port.writable.getWriter()
                // writer = outputStream.getWriter();
                const sata = data
                const data1 = new Uint8Array(sata) // hello// 82, 76, 0, 0, 0, 82, 0, 0, 0, 66, 0, 0, 1, 0, 1,
                console.log('send data:+', data1)

                await writer.write(data1)

                writer.releaseLock()
            }
        } catch (e) {
            console.log(e)
        }
    }

    showUploadSucessError = (message) => {
        const success = message.includes('Successfully')
        this.setState({
            uploadSucessError: {
                isShow: true,
                message: message,
            },
            uploadOpen: false,
            hasUploaded: success ? true : this.state.hasUploaded,
        })
        setTimeout(() => {
            this.setState({
                uploadSucessError: {
                    isShow: false,
                    message: '',
                },
            })
            
            if (success && this.props.data) {
                ContentEngine.next()
            }
        }, 2500)
    }

    bytesSending = async (data) => {
        // if (
        //     (sessionStorage.getItem('connectedDevice') == 'Ace' &&
        //         sessionStorage.getItem('deviceVersion')?.includes('1.0.0')) ||
        //     sessionStorage.getItem('deviceVersion').includes('2.0.0')
        // ) {

        let connectedDevice = sessionStorage.getItem('connectedDevice')
        let deviceVersion = sessionStorage.getItem('deviceVersion')
        let assemblyPageAi = this.props.assembly.assemblyPageAi
        let hexProgram = this.props.logic.program
        let PortConnections = this.props.assembly.PortConnections
        const ispcAiTool1Present = isAi1ShowCondition({
            connectedDevice,
            deviceVersion,
        })
        let aIdata = [],
            aIRestData = []
        //generat the peeCee Ai Data
        if (ispcAiTool1Present && PortConnections?.A?.type == 'pcAiTool') {
            aIdata = generateAidata(hexProgram)
            aIRestData = generateAiresetdata(
                hexProgram,
                this.props.device?.aiVersion
            )
        }

        try {
            console.log('data is write', data, this.props.worker)
            if (['Roboki', 'Atr'].includes(connectedDevice)) {
                if (data.length > 1020) {
                    this.setState({ uploadOpen: false })
                    this.setState({ excitDataLimitPopup: true })
                    return
                }
            }

            this.props.worker.postMessage({
                type: 'writeArray',
                value: data,
            })
            const doneObj = { sendDataAsPacket: false, readVal: '' }
            // sessionStorage.setItem('sendData_read', JSON.stringify(doneObj))
            this.sendDataRef.current = doneObj

            let replyOK = ''
            try {
                replyOK = await Promise.race([
                    this.checkOk(),
                    this.timeoutPromise(5000), //
                ])
            } catch (e) {
                console.log('ERROR', e)
                this.showUploadSucessError('Program uploading failed')
            }

            let replayAisOk = ''
            let replayAIROk = ''
            if (replyOK == 'OK') {
                //for peeCee v1.0 send the ai module data

                if (
                    // ispcAiTool1Present &&
                    PortConnections?.A?.type == 'pcAiTool'
                ) {
                    this.props.worker.postMessage({
                        type: 'WriteArrayFormat1310',
                        value: aIdata,
                    })
                    const doneObj = { sendDataAsPacket: false, readVal: '' }
                    this.sendDataRef.current = doneObj
                    // sessionStorage.setItem(
                    //     'sendData_read',
                    //     JSON.stringify(doneObj)
                    // )
                    try {
                        replayAisOk = await Promise.race([
                            this.checkOk(),
                            this.timeoutPromise(5000), //
                        ])
                    } catch (e) {
                        console.log(e)
                        if (ispcAiTool1Present) {
                            this.showUploadSucessError(
                                `Program upload to the AI module failed. Please ensure that, the AI module is properly connected to the ${getDeviceName(
                                    connectedDevice
                                )}`
                            )
                        } else {
                            this.setState({ lowerVersionPcAiToolShow: true })
                        }
                    }
                } else {
                    //for roboki reset bytes send after 600ms other awaise not work for dc motor program
                    // if (['Roboki'].includes(connectedDevice)) {
                    //     await new Promise((reslove) => setTimeout(reslove, 600))
                    // }

                    this.props.worker.postMessage({
                        type: 'write',
                        value: 'REST',
                    })
                    this.showUploadSucessError('Program Successfully Uploaded')
                    // this.setState({
                    //     uploadSucessError: {
                    //         isShow: true,
                    //         message: 'Uploading Successful',
                    //     },
                    // })
                    // this.setState({ uploadOpen: false })
                    // setTimeout(
                    //     () =>
                    //         this.setState({
                    //             uploadSucessError: {
                    //                 isShow: false,
                    //                 message: '',
                    //             },
                    //         }),
                    //     2500
                    // )
                }
            }

            if (PortConnections?.A?.type == 'pcAiTool') {
                if (replayAisOk[3] == 83 && replayAisOk[4] == 1) {
                    this.props.worker.postMessage({
                        type: 'WriteArrayFormat1310',
                        value: aIRestData,
                    })
                    const doneObj = { sendDataAsPacket: false, readVal: '' }
                    // sessionStorage.setItem('sendData_read', JSON.stringify(doneObj))
                    this.sendDataRef.current = doneObj
                    try {
                        replayAIROk = await Promise.race([
                            this.checkOk(),
                            this.timeoutPromise(2000), //
                        ])
                    } catch (e) {
                        console.log('ERROR', e)
                        if (ispcAiTool1Present) {
                            this.showUploadSucessError(
                                `Program upload to the AI module failed. Please ensure that, the AI module is properly connected to the ${getDeviceName(
                                    connectedDevice
                                )}`
                            )
                        } else {
                            this.setState({ lowerVersionPcAiToolShow: true })
                        }
                    }
                } else {
                    // this.setState({ uploadOpen: false })
                    // window.alert('proggam does not upload.')
                    if (ispcAiTool1Present) {
                        this.showUploadSucessError(
                            `Program upload to the AI module failed. Please ensure that, the AI module is properly connected to the ${getDeviceName(
                                connectedDevice
                            )}`
                        )
                    } else {
                        this.setState({ lowerVersionPcAiToolShow: true })
                    }
                }

                if (replayAIROk[3] == 88 && replayAIROk[4] == 1) {
                    this.props.worker.postMessage({
                        type: 'write',
                        value: 'REST',
                    })
                    this.showUploadSucessError('Program Successfully Uploaded')
                    // this.setState({
                    //     uploadSucessError: {
                    //         isShow: true,
                    //         message: 'Uploading Successful',
                    //     },
                    // })
                    // this.setState({ uploadOpen: false })
                    // setTimeout(
                    //     () =>
                    //         this.setState({
                    //             uploadSucessError: {
                    //                 isShow: false,
                    //                 message: '',
                    //             },
                    //         }),
                    //     2500
                    // )
                }
            }
            // console.log('XXXXXXXXXXXXX', replyOK)
        } catch (e) {
            const doneObj = { sendDataAsPacket: true, readVal: '' }
            // sessionStorage.setItem('sendData_read', JSON.stringify(doneObj))
            this.sendDataRef.current = doneObj
            console.log('Error', e)
            // setDisplay('block')
        }
    }
    uploadProgram = async ({ save }) => {
        //for clearing the chunks
        this.props.worker.postMessage({
            type: 'clearChunks',
        })
        sessionStorage.setItem('isPlay', false)
        var params = {
            screen: 'hexa',
            logic: this.props.logic,
            // logicTwo wires ports into the assemblyTwo slice (see
            // ensureAssemblyConnections / PORT_CONNECTION_TWO), NOT the legacy
            // `assembly` slice which stays empty here. Reading `assembly`
            // produced empty PortConnections, so byte gen emitted malformed
            // servo commands (o{:31::}) and left the port unconfigured — the
            // output never turned off (LED stayed constantly ON).
            components:
                this.props.assemblyTwo?.PortConnections ||
                this.props.assembly.PortConnections,
            internalaccessories: JSON.parse(sessionStorage.getItem('concept'))
                .internalaccessories,
        }
        if (sessionStorage.getItem('PET') == null) {
            this.setState({ checkEndProgram: true })
            return
        }
        console.log(this.props.logic)
        if (!save) {
            this.setState({ uploadOpen: true })
        }
        if (this.state.checkEndProgram) return
        if (!this.props.webSerial.isConnected) {
            console.log('No device connected')
            if (this.props.data) {

                this.props.deviceMismatch({ deviceMismatched: {} })
                // Expansion kit: show inline reconnect dialog, no navigation
                this.setState({ showReconnectModal: true, uploadOpen: false })
            } else {
                this.setState({ modalIsOpen: true, uploadOpen: false })
            }
            return
        }

        // Verify the connected device matches the tutorial's expected device.
        // SubprogramRunner overwrites sessionStorage.connectedDevice with the
        // tutorial's allowedDevice on every render, so we use Redux
        // state.device.connectedDevice which only updates via deviceDetails
        // dispatches (actual USB scans) — making it the reliable physical
        // device indicator.
        if (this.props.data) {
            const allowedDevice = (
                sessionStorage.getItem('allowedDevice') || ''
            ).toLowerCase()
            const physicalDevice = (
                this.props.device?.connectedDevice || ''
            ).toLowerCase()
            if (
                physicalDevice &&
                allowedDevice &&
                physicalDevice !== allowedDevice
            ) {
                console.log(
                    `Device mismatch: connected=${physicalDevice}, expected=${allowedDevice}`
                )
                this.props.deviceMismatch({ deviceMismatched: {} })
                this.setState({
                    showReconnectModal: true,
                    reconnectStatus: 'mismatch',
                    uploadOpen: false,
                })
                return
            }
        }

        //debugger;
        var upldbtn = document.getElementById('uploadLogicscrn')
        upldbtn.style.pointerEvents = 'none'
        upldbtn.style.cursor = 'none'
        await getBytes({ code: params })
        let bytes = sessionStorage.getItem('convert_Bytes')
        var data = bytes.split(',')
        console.log(data, 'KAMAL SIMULATE')
        //this.myRef.current.upload();

        // await this.writePort(data);
        // this.readForSucess();

        // Sending Bytes and Receiving for 'OK' acknowledgement
        // const writer = this.props.webSerial.port.writable.getWriter();
        // await writer.releaseLock();
        // const reader = await this.props.webSerial.port.readable.getReader();
        // await reader.releaseLock()

        /** if (
            !(
                sessionStorage.getItem('deviceVersion')?.startsWith('1') &&
                ['Ace'].includes(sessionStorage.getItem('connectedDevice'))
            ) &&
            !['Humanoid', 'Roboki', 'Hexapod'].includes(
                sessionStorage.getItem('connectedDevice')
            )
        ) {
            console.log(this.props.webSerial.port.readable.locked, 'gsk prot')
            try {
                await this.props.webSerial.port.readable.cancel()
            } catch (e) {
                console.log(e)
            }
        }
**/

        if (save) {
            return data
        } else {
            await this.bytesSending(data)
            setTimeout(() => {
                upldbtn.style.cursor = 'pointer'
                upldbtn.style.pointerEvents = 'all'
            }, 2500)
        }
    }
    //older firmware upload with ack
    // uploadProgram = () => {
    //   var params = {
    //     screen: "hexa",
    //     logic: this.props.logic,
    //     components: this.props.assembly.PortConnections,
    //     internalaccessories: JSON.parse(sessionStorage.getItem("concept"))
    //       .internalaccessories,
    //   };
    //   this.setState({ uploadOpen: true });
    //   var upldbtn = document.getElementById("uploadLogicscrn");
    //   upldbtn.style.pointerEvents = "none";
    //   upldbtn.style.cursor = "none";
    //   getBytes({ code: params });
    //   let bytes = sessionStorage.getItem("convert_Bytes");
    //   var data = bytes.split(",");
    //   console.log(data, "KAMAL SIMULATE");
    //   //this.myRef.current.upload();
    //   // this.writePort(data);
    //   sendBytes(data, this.props.webSerial.port);
    //   setTimeout(() => {
    //     upldbtn.style.cursor = "pointer";

    //     upldbtn.style.pointerEvents = "all";
    //     this.setState({ uploadOpen: false });
    //   }, 3000);

    //   // console.log("UPLOAD DATA", this.myRef.current.upload()); //it will call anyFun which is available at simulateLogic.js
    // };

    //checks if the current connected device is support to save the program to the board
    getIsSaveToBoard = () => {
        let connectedDevice = sessionStorage.getItem('connectedDevice')
        let deviceVersion = sessionStorage.getItem('deviceVersion')

        // Supported device versions
        let supportedDevice = {
            Humanoid: { major: 3 },
            Hexapod: { major: 3 },
            Klaw: { major: 1, patch: 3 }, // Klaw requires minor version check too
        }

        if (
            !deviceVersion ||
            !connectedDevice ||
            !supportedDevice?.[connectedDevice]
        ) {
            return false
        }

        const [majorStr, minorStr, patchStr] = deviceVersion.split('.')
        const major = parseInt(majorStr, 10)
        const patch = parseInt(patchStr, 10)

        const required = supportedDevice[connectedDevice]

        // Special case for Klaw (requires major + minor check)
        if (connectedDevice === 'Klaw') {
            return (
                major > required.major ||
                (major === required.major && patch >= required.patch)
            )
        }

        // Default check for other devices (major version only)
        return major >= required.major
    }

    setFilePopUp = (value) => {
        this.setState({ filePopup: value })
    }

    //save hex programming to the board bytes format
    programsaveToBoard = async (microPython) => {
        if (microPython) {
            return
        }
        // saveToLocalStorage()
        if (
            this.state.readyForSimulation !== 'repeat' &&
            this.state.readyForSimulation !== 'end'
        ) {
            this.setState({ checkEndProgram: true })
        } else {
            return await this.uploadProgram({ save: true })
        }
    }

    goBack = () => {
        if (this.props.data) {
            // Shell/Make mode: go to the previous screen's first (starting) step
            ContentEngine.prevToStart()
        } else {
            history.back()
        }
    }

    loadLogicSteps = async () => {
        // 1. CAPTURE THE PROP SYNCHRONOUSLY HERE
        const capturedInitialStep = this.props.initialStep

        try {
            // 1. Get dynamic parameters from URL
            const isPreviewMode = this.getIsPreviewMode()
            const apiProjectId = this.getCurrentProjectId()

            if (isPreviewMode) {
                sessionStorage.setItem('apiProjectId', apiProjectId)
            }

            let stepsData

            if (this.props.data) {
                // Use provided data. SubprogramRunner (both live and preview)
                // hands us the current hex screen's content directly, so prefer
                // it whenever present — regardless of preview mode. (Previously
                // this was gated on `!isPreviewMode`, but now that preview mode
                // is also detected via ContentEngine.staging, that guard would
                // wrongly force a redundant network fetch in make-preview.)
                stepsData = normalizeHexSteps(this.props.data)
            } else {
                const hexScreenId = this.getCurrentScreenId()
                stepsData = await fetchHexSteps(
                    apiProjectId,
                    isPreviewMode,
                    hexScreenId
                )
            }

            await this.ensureAssemblyConnections(stepsData?.assemblyScreenId)

            // Pre-compute micro-slides for v2.0 format
            let microSlides = []
            if (stepsData?.version === '2.0' && stepsData?.steps) {
                microSlides = flattenToMicroSlides(stepsData)
            }

            // Retrieve the saved step from explicit props OR sessionStorage
            const storageKey = `logic_step_${this.getCurrentProjectId()}_${this.getCurrentScreenId() || 'default'}`
            let savedStep = 0

            // 2. CHANGE THIS CONDITION TO USE THE CAPTURED VARIABLE
            if (
                capturedInitialStep !== undefined &&
                capturedInitialStep !== null
            ) {
                // PRIORITY 1: Explicit jump from ContentEngine (e.g., clicking Next/Prev)
                savedStep = capturedInitialStep - 1 // Convert 1-based to 0-based index
                sessionStorage.setItem(storageKey, savedStep.toString())
            } else {
                // PRIORITY 2: Page reload / Memory from last visit
                const savedStepStr = sessionStorage.getItem(storageKey)
                // if (parseInt(savedStepStr, 10) == microSlides.length) {
                //     savedStep = microSlides.length - 1
                // }
                console.log(
                    'Saved step from sessionStorage:',
                    savedStepStr,
                    'Parsed:',
                    parseInt(savedStepStr, 10),
                    'MicroSlides Length:',
                    microSlides.length
                )
                savedStep =
                    savedStepStr &&
                    !isNaN(savedStepStr) &&
                    parseInt(savedStepStr, 10) < microSlides.length
                        ? parseInt(savedStepStr, 10)
                        : 0
            }

            // Ensure the saved step doesn't exceed the available steps
            const totalSlides = stepsData?.steps
                ? microSlides.length
                : Number(
                      stepsData?.totalSteps || stepsData?.steps?.length || 0
                  ) || 0

            if (savedStep >= totalSlides && totalSlides > 0) {
                savedStep = totalSlides - 1
            }

            this.setState(
                {
                    logicSteps: stepsData,
                    microSlides: microSlides,
                    stepsSlideIndex: savedStep,
                    aiVoiceover:
                        sessionStorage.getItem('aiVoiceToggle') !== 'false',
                    subtitleVisible: false,
                    showSubtitleDisplay: false,
                    aiSpeaking: true,
                },
                () => {
                    // Reset the board to the target step BEFORE revealing it, so
                    // the stale previous-visit program never shows.
                    this.clearAndRebuildToStep(savedStep)
                    // Now the correct step is built — safe to render the board.
                    this.setState({ stepsReady: true })
                    this._syncShellProps()
                    const instruction = this.getCurrentInstruction()
                    this.runTypewriterEffect(instruction)

                    if (this.state.aiVoiceover) {
                        this.playAudioForStep(savedStep)
                    }

                    // Slide in the subtitle box after a short delay
                    setTimeout(
                        () =>
                            this.setState({
                                subtitleVisible: true,
                                showSubtitleDisplay: true,
                            }),
                        50
                    )
                }
            )

            console.log('Loaded logic steps:', stepsData)
        } catch (error) {
            console.error('Failed to load logic steps', error)
            // Never leave the board gated on error — reveal whatever we have.
            if (this._isMounted) this.setState({ stepsReady: true })
        }
    }

    playAudioForStep = (slideIndex) => {
        const stepNumber = slideIndex + 1
        const { logicSteps } = this.state

        if (!logicSteps?.meta?.audioBaseUrl) {
            console.warn('Audio Player: Missing audioBaseUrl in logicSteps')
            return
        }

        // Map slide index to the correct audio file number.
        // Slides 0..totalSlides-1 are micro-slides (audio files 1..totalSlides).
        // Slide at totalSlides = finalStep1 (audio file totalSlides+1).
        // Slide at totalSlides+1 = finalStep2 (audio file totalSlides+2).
        const totalSlides = this.getStepsSlideCount(logicSteps)
        const fileName = `${stepNumber}.mp3?t=${Date.now()}`

        const audioUrl = `${logicSteps.meta.audioBaseUrl}${fileName}`

        // In Make mode, play through the shell's persistent (pre-unlocked)
        // audio element so playback survives cross-screen navigation. Fall
        // back to the local element in standalone mode.
        if (this.context?.playAudio) {
            this.context.playAudio(audioUrl)
            return
        }

        if (!this.audioRef.current) {
            console.warn('Audio Player: Missing audio ref')
            return
        }
        this.audioRef.current.src = audioUrl
        this.audioRef.current
            .play()
            .catch((e) => console.log('Playback interrupted or failed:', e))
    }

    //  TOGGLE BUTTONS

    // Toggle Voiceover
    handleAiVoiceoverToggle = () => {
        this.setState(
            (prevState) => ({
                aiVoiceover: !prevState.aiVoiceover,
            }),
            () => {
                // Callback runs AFTER state update
                sessionStorage.setItem(
                    'aiVoiceToggle',
                    String(this.state.aiVoiceover)
                )
                if (!this.state.aiVoiceover) {
                    // Turning OFF: Pause audio (shell element in Make mode,
                    // local element otherwise)
                    if (this.context?.stopAudio) {
                        this.context.stopAudio()
                    } else if (this.audioRef.current) {
                        this.audioRef.current.pause()
                        this.audioRef.current.currentTime = 0
                    }
                } else {
                    // Turning ON: Play current step
                    this.playAudioForStep(this.state.stepsSlideIndex)
                }
            }
        )
    }

    // Handle Fullscreen
    handleFullscreen = () => {
        // In Make mode, fullscreen the parent wrapper so it persists across screen transitions
        const el = this.context
            ? document.querySelector('.make-page')
            : this.appContainerRef.current

        const isFullscreen =
            document.fullscreenElement ||
            document.webkitFullscreenElement ||
            document.msFullscreenElement

        if (!isFullscreen) {
            if (el?.requestFullscreen) el.requestFullscreen()
            else if (el?.webkitRequestFullscreen) el.webkitRequestFullscreen()
            else if (el?.msRequestFullscreen) el.msRequestFullscreen()
        } else {
            if (document.exitFullscreen) document.exitFullscreen()
            else if (document.webkitExitFullscreen)
                document.webkitExitFullscreen()
            else if (document.msExitFullscreen) document.msExitFullscreen()
        }
    }

    handleStepsPrev = () => {
        if (this.state.isReplaying) return

        // At step 1 — Previous goes to the last step of the previous screen.
        if (this.state.stepsSlideIndex === 0) {
            const isPreviewMode = new URLSearchParams(
                this.props.history?.location?.search || window.location.search
            ).get('preview') === 'true'
            if (!isPreviewMode && this.props.data) ContentEngine.prev()
            return
        }

        // 2. If we aren't at the first step, just go back one tutorial step
        const stepsData = this.state.logicSteps
        if (!stepsData) return

        const nextIndex = Math.max(this.state.stepsSlideIndex - 1, 0)

        // Update state and rebuild the board for the previous step
        this.clearAndRebuildToStep(nextIndex)

        this.setState({
            stepsSlideIndex: nextIndex,
            showSubtitleDisplay: true,
        })

        if (this.state.aiVoiceover) {
            this.playAudioForStep(nextIndex)
        }

        setTimeout(() => {
            this.checkTutorialDeviation()
        }, 100)
    }

    handleStepsNext = async () => {
        if (this.state.isReplaying) return // Prevent clicking while animating

        const stepsData = this.state.logicSteps
        if (!stepsData) return

        // console.log('stepsSlideIndex: ', this.state.stepsSlideIndex, "total steps: ", this.getStepsSlideCount(stepsData))

        const totalSlides = this.getStepsSlideCount(stepsData)
        if (!totalSlides) return

        let nextIndex = null
        // CHANGED: Allow nextIndex to reach totalSlides
        if (this.state.stepsSlideIndex < totalSlides) {
            const nextStep = this.state.stepsSlideIndex + 1
            nextIndex = nextStep
            const globalStep = ContentEngine.getCurrentScreenOffset() + nextStep
            ContentEngine.tryEarnStep(globalStep)
            this.setState({
                stepsSlideIndex: nextIndex,
                showSubtitleDisplay: true,
            })
        } else {
            // Final slide
            const searchString =
                this.props.history?.location?.search || window.location.search
            const urlParams = new URLSearchParams(searchString)
            const isPreviewMode = urlParams.get('preview') === 'true'
            if (isPreviewMode) return

            if (!this.state.hasUploaded) {
                this.setState({ showSkipUploadModal: true })
                return
            }

            if (this.props.data) {
                ContentEngine.next()
                return
            } else {
                this.props.history.push('/SimulateNew')
            }
        }

        if (nextIndex === null) return

        // Clear the hex board and rebuild from scratch up to the new step
        this.clearAndRebuildToStep(nextIndex)

        if (this.state.aiVoiceover) {
            this.playAudioForStep(nextIndex)
        }

        setTimeout(() => {
            this.checkTutorialDeviation()
        }, 100)
    }

    clearAndRebuildToStep = (targetIndex) => {
        const stepsData = this.state.logicSteps
        if (!stepsData) return

        // CHANGED: Cap the target index so we don't look out of bounds on the upload step
        const totalSlides = this.getStepsSlideCount(stepsData)
        const logicTargetIndex = Math.min(
            targetIndex,
            Math.max(0, totalSlides - 1)
        )

        if (stepsData.version === '2.0' && stepsData.steps) {
            // v2.0 format: build state from micro-slide descriptor
            const { microSlides } = this.state
            const microSlide = microSlides?.[logicTargetIndex]

            if (!microSlide) return // safeguard

            const { logic, currentActiveHexBlock } = buildStateForMicroSlide(
                stepsData.steps,
                microSlide
            )

            // Preserve the user's current zoom/pan instead of resetting every step
            const currentLogic = this.props.logic
            if (currentLogic) {
                if (currentLogic.offset)
                    logic.offset = { ...currentLogic.offset }
                if (currentLogic.scale != null) logic.scale = currentLogic.scale
            }

            // Snap `active` onto the block's TRUE rendered coordinates BEFORE the
            // first render. buildStateForMicroSlide sets `active` from the static
            // authored gridPosition, which ignores the column shift ProgramToDrawing
            // applies to container blocks (and everything after them). For a 2nd
            // Decision that lands inside the 1st Decision's rendered region, so the
            // panel would bind to the 1st Decision for a frame before
            // correctTutorialActiveCoords re-snapped it (the "old data flashes, then
            // corrects" glitch). Correcting here means no uncorrected frame renders.
            if (
                logic.bottomPanel === 'show' &&
                Array.isArray(logic.active) &&
                logic.active[0] !== -1
            ) {
                const codeStep =
                    stepsData.steps[microSlide.codeStepIndex]
                if (codeStep) {
                    const JSON_TO_INTERNAL = {
                        action: 'hardware',
                        decision: 'condition',
                        stop: 'end',
                    }
                    const internalType =
                        JSON_TO_INTERNAL[codeStep.blockType] ||
                        codeStep.blockType
                    const targetRow = codeStep.gridPosition?.row
                    const occurrenceIndex = this.getBlockTypeOccurrenceIndex(
                        microSlide.codeStepIndex,
                        internalType,
                        targetRow
                    )
                    // Lay out the freshly-built program to read TRUE coordinates.
                    const tempDrawing = ProgramToDrawing(
                        undefined,
                        logic.program,
                        logic.end,
                        logic.currentProgramGuide,
                        logic.active,
                        this.add,
                        logic.insertState,
                        this.insertNode,
                        this.insertBtwnNode,
                        this.deleteNode
                    )
                    const trueCoords = this.findActionHexCoordsForType(
                        internalType,
                        occurrenceIndex,
                        tempDrawing.board,
                        targetRow
                    )
                    if (trueCoords) {
                        logic.active = trueCoords
                    }
                }
            }

            // Apply the built logic to Redux
            this.props.update(JSON.parse(JSON.stringify(logic)))

            // Set currentActiveHexBlock in sessionStorage
            if (currentActiveHexBlock) {
                sessionStorage.setItem(
                    'currentActiveHexBlock',
                    JSON.stringify(currentActiveHexBlock)
                )
            } else {
                sessionStorage.removeItem('currentActiveHexBlock')
            }

            this.props.setHexActiveStep({ stepIndex: logicTargetIndex })

            // Sync readyForSimulation with the end state
            const endState = logic.end?.state
            if (endState === 'repeat' || endState === 'end') {
                this.setState({ readyForSimulation: endState })
                sessionStorage.setItem('programEnd', endState)
                sessionStorage.setItem('PET', 'repeat')
            } else {
                this.setState({ readyForSimulation: '' })
                sessionStorage.removeItem('programEnd')
                sessionStorage.removeItem('PET')
            }
        } else if (stepsData.version === '2.0' && stepsData.steps) {
            // v1.0 legacy format: apply state snapshot directly
            const clearedLogic = JSON.parse(JSON.stringify(defaultLogic))
            // Preserve the user's current zoom/pan
            const currentLogic = this.props.logic
            if (currentLogic) {
                if (currentLogic.offset)
                    clearedLogic.offset = { ...currentLogic.offset }
                if (currentLogic.scale != null)
                    clearedLogic.scale = currentLogic.scale
            }
            this.props.update(clearedLogic)
            sessionStorage.removeItem('currentActiveHexBlock')

            if (logicTargetIndex >= 0) {
                const targetStep = stepsData.steps[logicTargetIndex]
                this.applyReplayStepDirect(targetStep)
                this.props.setHexActiveStep({ stepIndex: logicTargetIndex })

                const stepLogic = targetStep?.hexState?.logicTwo
                if (stepLogic && stepLogic.end) {
                    const endState = stepLogic.end.state
                    if (endState === 'repeat' || endState === 'end') {
                        this.setState({ readyForSimulation: endState })
                        sessionStorage.setItem('programEnd', endState)
                        sessionStorage.setItem('PET', 'repeat')
                    } else {
                        this.setState({ readyForSimulation: '' })
                        sessionStorage.removeItem('programEnd')
                        sessionStorage.removeItem('PET')
                    }
                }
            }
        }
    }

    // ── Tutorial helper: check if we are in an active v2.0 tutorial ──
    isTutorialMode = () => {
        const { logicSteps, microSlides } = this.state
        return !!(logicSteps?.version === '2.0' && logicSteps?.steps?.length > 0 && microSlides?.length > 0)
    }


    isEndToggleLocked = () => {
        if (!this.isTutorialMode()) return false
        const expected = this.getExpectedTutorialAction()
        if (!expected) return true
        return !(
            expected.type === 'PANEL_CHANGE' ||
            expected.type === 'SELECT_READ_SOURCE' ||
            expected.type === 'READ_SENSOR'
        )
    }

    /**
     * Determine what user action is expected to advance from the current tutorial slide.
     * Returns { type, ... } or null if no tutorial is active.
     */
    getExpectedTutorialAction = () => {
        const { logicSteps, stepsSlideIndex, microSlides } = this.state
        if (!logicSteps?.steps || !logicSteps?.version || !microSlides?.length) return null

        const totalSlides = this.getStepsSlideCount(logicSteps)
        if (stepsSlideIndex >= totalSlides) return null

        const slide = microSlides[stepsSlideIndex]
        if (!slide) return null

        const codeStep = logicSteps.steps[slide.codeStepIndex]
        if (!codeStep && slide.phase !== 'complete') return null

        const subSteps = codeStep?.subSteps || []

        switch (slide.phase) {
            case 'pre_select':
                return { type: 'CLICK_HEX' }

            case 'select_active': {
                const internalType =
                    TUTORIAL_BLOCK_TYPE_MAP[codeStep.blockType] ||
                    codeStep.blockType
                return { type: 'ADD_BLOCK', expectedBlockType: internalType }
            }

            case 'block_placed':
            case 'block_inserted': {
                if (subSteps.length > 0) {
                    return this._subStepToExpectedAction(subSteps[0])
                }
                // FIX: No sub-steps? Wait for the user to click anywhere.
                return { type: 'CLICK_ANYWHERE' }
            }

            case 'after_substep': {
                // Synthesized slides (e.g. Read Button from SELECT_READ_SOURCE) override the expected action
                if (slide.overrideExpectedAction) {
                    return slide.overrideExpectedAction
                }
                const nextSubIndex = (slide.subStepIndex ?? -1) + 1
                if (nextSubIndex < subSteps.length) {
                    return this._subStepToExpectedAction(subSteps[nextSubIndex])
                }
                // FIX: Finished all sub-steps? Wait for the user to click anywhere.
                return { type: 'CLICK_ANYWHERE' }
            }

            case 'pre_insert':
                return { type: 'CLICK_HEX' }

            case 'insert_choose': {
                const internalType =
                    TUTORIAL_BLOCK_TYPE_MAP[codeStep.blockType] ||
                    codeStep.blockType
                return {
                    type: 'INSERT_BLOCK',
                    expectedBlockType: internalType,
                }
            }

            case 'insert_menu_open': // <-- NEW
                return { type: 'CLICK_HEX' } // Expects clicking the insert (+) mini-button

            case 'pre_delete':
                return { type: 'CLICK_HEX' }

            case 'delete_menu_open': // <-- NEW
            case 'delete_active':
            case 'do_delete':
            case 'delete_block':
                return { type: 'DELETE_BLOCK' }

            case 'block_deleted':
                // FIX: Block deleted successfully? Wait for the user to click anywhere.
                return { type: 'CLICK_ANYWHERE' }
            case 'complete':
                // FIX: Block deleted successfully? Wait for the user to click anywhere.
                return { type: 'CLICK_ANYWHERE' }

            default:
                return null
        }
    }

    /** Map a subStep descriptor to an expected-action object */
    _subStepToExpectedAction = (subStep) => {
        if (!subStep) return null
        switch (subStep.action) {
            case 'OPEN_MENU':
                return { type: 'OPEN_PANEL' }
            case 'CLOSE_MENU':
                return { type: 'CLOSE_PANEL' }
            case 'TOGGLE_HARDWARE':
            case 'SET_VALUE':
            case 'SET_STATE':
                return {
                    type: 'PANEL_CHANGE',
                    hardwareKey: subStep.hardwareKey,
                    expectedValue: subStep.expectedValue,
                }
            case 'SELECT_READ_SOURCE':
                return {
                    type: 'SELECT_READ_SOURCE',
                    hardwareKey: '_readSource',
                    expectedValue: subStep.expectedValue,
                }
            case 'READ_SENSOR':
                return {
                    type: 'READ_SENSOR',
                    hardwareKey: '_readAction',
                    expectedValue: subStep.expectedValue,
                }
            default:
                return null
        }
    }

    /** Advance to the next tutorial slide (called when user performs the expected action) */
    advanceTutorialStep = () => {
        if (!this._isMounted) return // 🟢 FIX: Prevent unmounted updates

        const { stepsSlideIndex, logicSteps } = this.state
        if (!logicSteps) return
        const totalSlides = this.getStepsSlideCount(logicSteps)
        const nextIndex = stepsSlideIndex + 1
        if (nextIndex > totalSlides) return

        // Earn the step the user just completed by performing the required action.
        const completedStepNum = stepsSlideIndex + 1 // 1-based
        const globalStep = ContentEngine.getCurrentScreenOffset() + completedStepNum
        ContentEngine.tryEarnStepAutoAdvance(globalStep)

        console.log(
            `Tutorial auto-advance: step ${stepsSlideIndex} \u2192 ${nextIndex}`
        )

        // FIX: Force a perfect rebuild to the next step's expected state
        // This ensures the BottomPanel stays open and active!
        this.clearAndRebuildToStep(nextIndex)

        this.setState(
            {
                stepsSlideIndex: nextIndex,
                tutorialDeviation: false,
                showSubtitleDisplay: true,
            },
            () => {
                const instruction = this.getCurrentInstruction()
                this.runTypewriterEffect(instruction)
                if (this.state.aiVoiceover) {
                    this.playAudioForStep(nextIndex)
                }
                const storageKey = `logic_step_${this.getCurrentProjectId()}_${this.getCurrentScreenId() || 'default'}`
                sessionStorage.setItem(storageKey, nextIndex.toString())
            }
        )
    }

    autoAdvanceStepIfNeeded = () => {
        const { logicSteps, stepsSlideIndex, isReplaying } = this.state
        const currentLogic = this.props.logic

        // Do not auto-advance if an animation is playing or data isn't loaded
        if (isReplaying || !logicSteps) return

        // v2.0 format: auto-advance is handled by action-based detection
        // in click / add / toggleBottomPanel / bottomPanelChange methods.
        if (logicSteps.version === '2.0' && logicSteps.steps) return

        const totalSlides = this.getStepsSlideCount(logicSteps)
        // If we are already at the last step, there's nowhere to advance to
        if (stepsSlideIndex >= totalSlides - 1) return

        const nextIndex = stepsSlideIndex + 1

        if (logicSteps.version === '2.0' && logicSteps.steps) {
            // v1.0 legacy format
            const nextStep = logicSteps.steps[nextIndex]
            if (!nextStep || !nextStep.hexState || !nextStep.hexState.logicTwo)
                return
            const expectedNextLogic = nextStep.hexState.logicTwo

            if (this.compareLogicStates(expectedNextLogic, currentLogic)) {
                console.log(
                    `User completed action! Auto-advancing to step: ${nextIndex + 1}`
                )

                // Earn the step the user just completed (v1.0 auto-advance).
                const completedStepNum = stepsSlideIndex + 1
                const globalStep = ContentEngine.getCurrentScreenOffset() + completedStepNum
                ContentEngine.tryEarnStepAutoAdvance(globalStep)

                this.setState(
                    {
                        stepsSlideIndex: nextIndex,
                        tutorialDeviation: false,
                    },
                    () => {
                        if (this.state.aiVoiceover) {
                            this.playAudioForStep(nextIndex)
                        }
                    }
                )
            }
        }
    }

    checkTutorialDeviation = () => {
        if (!this._isMounted) return // 🟢 FIX: Prevent unmounted updates

        const stepsData = this.state.logicSteps
        if (!stepsData) {
            this.setState({ tutorialDeviation: false })
            return
        }

        const slideIndex = this.state.stepsSlideIndex
        const totalSlides = this.getStepsSlideCount(stepsData)

        if (!totalSlides || slideIndex >= totalSlides) {
            this.setState({ tutorialDeviation: false })
            return
        }

        const currentLogic = this.props.logic

        if (stepsData.version === '2.0' && stepsData.steps) {
            // v2.0 format: build expected state from micro-slide
            const { microSlides } = this.state
            const currentMicroSlide = microSlides?.[slideIndex]
            if (!currentMicroSlide) {
                this.setState({ tutorialDeviation: false })
                return
            }
            const { logic: expectedLogic } = buildStateForMicroSlide(
                stepsData.steps,
                currentMicroSlide
            )
            const hasDeviation = !this.compareLogicStates(
                expectedLogic,
                currentLogic
            )
            this.setState({ tutorialDeviation: hasDeviation })
        } else if (stepsData.version === '2.0' && stepsData.steps) {
            // v1.0 legacy format
            const currentStep = stepsData.steps[slideIndex]
            if (
                !currentStep ||
                !currentStep.hexState ||
                !currentStep.hexState.logicTwo
            ) {
                this.setState({ tutorialDeviation: false })
                return
            }
            const expectedLogic = currentStep.hexState.logicTwo
            const hasDeviation = !this.compareLogicStates(
                expectedLogic,
                currentLogic
            )
            this.setState({ tutorialDeviation: hasDeviation })
        } else {
            this.setState({ tutorialDeviation: false })
        }
    }

    sanitizeLogicForComparison = (logicObj) => {
        if (!logicObj) return logicObj

        // Deep clone using lodash to prevent mutating the actual Redux state
        const cloned = _.cloneDeep(logicObj)

        // 1. Remove top-level ignored keys
        delete cloned.offset
        delete cloned.scale

        // 2. Recursive function to remove volatile keys from the program array
        const removeIgnoredKeys = (nodes) => {
            if (!Array.isArray(nodes)) return

            nodes.forEach((node) => {
                // Remove engine-specific / volatile keys
                delete node.asgn5
                delete node.id
                delete node.row
                delete node.col
                delete node.nodeId
                delete node.newId

                if (node.state && typeof node.state === 'object') {
                    delete node.state.asgn5
                }

                // If there are subprograms (like loops/ifs), clean them recursively
                if (node.subprogram) {
                    removeIgnoredKeys(node.subprogram)
                }
            })
        }

        if (cloned.program) {
            removeIgnoredKeys(cloned.program)
        }

        return cloned
    }

    // UPDATED: Now uses the sanitizer to ignore specific keys
    compareLogicStates = (expected, current) => {
        // Sanitize both objects to remove offset, scale, and asgn5
        const sanitizedExpected = this.sanitizeLogicForComparison(expected)
        const sanitizedCurrent = this.sanitizeLogicForComparison(current)

        // Do a deep comparison on the cleaned objects
        return _.isEqual(sanitizedExpected, sanitizedCurrent)
    }

    resetTutorial = () => {
        const stepsData = this.state.logicSteps
        if (!stepsData) return

        // Reset to step 0
        const resetIndex = 0

        // Clear the hex board and rebuild from scratch to step 0
        this.clearAndRebuildToStep(resetIndex)

        // Update state
        this.setState({
            stepsSlideIndex: resetIndex,
            typewriterText: '',
            showSubtitleDisplay: true,
            aiSpeaking: true,
            tutorialDeviation: false,
        })

        // Play audio if voiceover is enabled
        if (this.state.aiVoiceover) {
            setTimeout(() => {
                this.playAudioForStep(resetIndex)
            }, 100)
        }

        // Save to sessionStorage
        const storageKey = `logic_step_${this.getCurrentProjectId()}_${this.getCurrentScreenId() || 'default'}`
        sessionStorage.setItem(storageKey, '0')
    }

    showReplayMessage = (message) => {
        this.setState({ replayMessage: message })
    }

    applyReplayStep = async (stepIndex) => {
        this.props.setHexActiveStep({ stepIndex })
        this.clearAndRebuildToStep(stepIndex)
    }

    handleHexStepsPlay = () => {
        if (this.state.isReplaying) {
            return
        }

        if (this.replayFileInputRef?.current) {
            this.replayFileInputRef.current.click()
        }
    }

    handleHexStepsFileSelect = (event) => {
        const file = event.target.files && event.target.files[0]
        if (!file) {
            return
        }

        const reader = new FileReader()
        reader.onload = () => {
            try {
                const payload = JSON.parse(reader.result)
                const steps = Array.isArray(payload?.steps) ? payload.steps : []

                if (!steps.length) {
                    this.setState({ replayMessage: 'No steps found in file.' })
                    return
                }

                this.startReplayFromSteps(steps)
            } catch (error) {
                console.error('Failed to parse steps file:', error)
                this.setState({ replayMessage: 'Invalid steps file.' })
            } finally {
                event.target.value = ''
            }
        }

        reader.readAsText(file)
    }

    startReplayFromSteps = (steps) => {
        if (this.state.isReplaying) {
            return
        }

        if (!Array.isArray(steps) || steps.length === 0) {
            if (this._isMounted) {
                this.setState({ replayMessage: 'No steps to replay.' })
            }
            return
        }

        if (this.replayTimerId) {
            clearTimeout(this.replayTimerId)
            this.replayTimerId = null
        }

        if (this._isMounted) {
            this.setState({
                isReplaying: true,
                replayIndex: 0,
                replayMessage: '',
            })
        }

        const playNext = async (index) => {
            console.log(`Playing step ${index} of ${steps.length}`)

            if (index >= steps.length) {
                if (this._isMounted) {
                    this.setState({ isReplaying: false, replayMessage: '' })
                }
                return
            }

            // Apply the step (for file-based replay, use direct state application)
            this.applyReplayStepDirect(steps[index])
            this.props.setHexActiveStep({ stepIndex: index })
            if (this._isMounted) {
                this.setState({ replayIndex: index })
            }

            this.replayTimerId = setTimeout(() => {
                playNext(index + 1)
            }, 5000)
        }

        console.log('Starting replay of steps:', steps)

        playNext(0)
    }

    applyReplayStepDirect = (step) => {
        if (!step || !step.hexState) return

        const nextLogic = step.hexState.logicTwo
            ? JSON.parse(JSON.stringify(step.hexState.logicTwo))
            : this.props.logic

        if (step.hexState.currentActiveHexBlock) {
            sessionStorage.setItem(
                'currentActiveHexBlock',
                JSON.stringify(step.hexState.currentActiveHexBlock)
            )
            if (nextLogic && nextLogic.bottomPanel !== 'show') {
                nextLogic.bottomPanel = 'show'
            }
        } else {
            sessionStorage.removeItem('currentActiveHexBlock')
        }

        this.props.update(nextLogic)
    }

    // 1. Get text for current step
    getCurrentInstruction = () => {
        const { logicSteps, stepsSlideIndex, microSlides } = this.state
        if (!logicSteps) return ''

        const totalSlides = this.getStepsSlideCount(logicSteps)

        // Check if we're on the final upload step (one beyond the normal steps)
        if (stepsSlideIndex === totalSlides) {
            return this.state.hasUploaded
                ? 'Excellent! Program uploaded. Proceeding to results…'
                : (logicSteps?.uploadStepInstruction || logicSteps?.finalStepInstruction2 || 'Upload the code to the device to see it in action!')
        }

        if (logicSteps.version === '2.0' && logicSteps.steps) {
            // v2.0 format: use micro-slide instruction
            const slide = microSlides?.[stepsSlideIndex]
            return slide?.instruction || ''
        }

        // v1.0 legacy format
        if (!logicSteps.steps) return ''
        const activeStep = logicSteps.steps[stepsSlideIndex]
        return activeStep ? activeStep.instruction : ''
    }

    // 2. Smart Typewriter (Updates state in background)
    runTypewriterEffect = (text) => {
        if (this.typewriterInterval) clearInterval(this.typewriterInterval)

        if (!text || !this.state.aiVoiceover) {
            this.setState({ typewriterText: text || '', aiSpeaking: false })
            return
        }

        this.setState({ typewriterText: '', aiSpeaking: true })

        let i = 0
        this.typewriterInterval = setInterval(() => {
            i++
            this.setState({ typewriterText: text.slice(0, i) })

            if (i >= text.length) {
                clearInterval(this.typewriterInterval)
                this.setState({ aiSpeaking: true })
            }
        }, 30)
    }

    // 3. Handle click outside to HIDE text
    handleClickOutside = (event) => {
        if (
            this.subtitleRef.current &&
            !this.subtitleRef.current.contains(event.target) &&
            this.state.showSubtitleDisplay
        ) {
            this.setState({ showSubtitleDisplay: false, aiSpeaking: true })
        }
    }

    getHexToHighlight = () => {
        const { logicSteps, stepsSlideIndex, microSlides } = this.state
        if (!logicSteps || !logicSteps.steps) return null

        const slide = microSlides?.[stepsSlideIndex]
        if (!slide) return null

        let targetHex = slide.highlightHex

        // MAGIC GRID SHIFT FIX
        // Because the Hex grid dynamically pads columns (+3) to avoid subprogram overlaps,
        // the static JSON target might point to an empty cell.
        // If the block is placed on the board, we search the physical render matrix
        // to find its TRUE visual location and snap the highlight box to it!
        if (slide.phase === 'block_placed' || slide.phase === 'after_substep') {
            const codeStep = logicSteps.steps[slide.codeStepIndex]
            if (codeStep) {
                // Map the JSON UI label back to the internal AST type
                const JSON_TO_INTERNAL = {
                    action: 'hardware',
                    decision: 'condition',
                    stop: 'end',
                }
                const internalType =
                    JSON_TO_INTERNAL[codeStep.blockType] || codeStep.blockType

                // Search the board for THIS occurrence of the block type, scoped to
                // the authored row, so e.g. the wait AFTER a loop (row 1) is not
                // confused with the wait INSIDE it (row 3) — they share a column.
                const targetRow = codeStep.gridPosition?.row
                const occurrenceIndex = this.getBlockTypeOccurrenceIndex(
                    slide.codeStepIndex,
                    internalType,
                    targetRow
                )
                const trueCoords = this.findActionHexCoordsForType(
                    internalType,
                    occurrenceIndex,
                    undefined,
                    targetRow
                )

                if (trueCoords) {
                    targetHex = `hex-block-${trueCoords[0]}-${trueCoords[1]}`
                }
            }
        }

        // SELECT-PHASE GRID SHIFT FIX
        // The "Select" hex (and the block chooser it opens) also shifts columns
        // once earlier container blocks widen the board, so the static JSON
        // coords go stale. Snap onto the Select hex's true rendered location.
        else if (slide.phase === 'pre_select') {
            const sel = this.findSelectHexCoords()
            if (sel) {
                targetHex = `hex-block-${sel[0]}-${sel[1]}`
            }
        } else if (slide.phase === 'select_active') {
            // `active` was already snapped onto the true Select hex in
            // componentWillUpdate, so the chooser is open here. Highlight the
            // chosen block's option, computed as the same offset from the Select
            // hex that ProgramToDrawing lays the option out at.
            const sel = this.findSelectHexCoords()
            const codeStep = logicSteps.steps[slide.codeStepIndex]
            if (sel && codeStep) {
                targetHex = getNewBlockPosition(
                    `hex-block-${sel[0]}-${sel[1]}`,
                    codeStep.blockType
                )
            }
        }

        return targetHex
    }

    /**
     * Determine which panel elements should be highlighted for the next step.
     * Returns { changedKeys: [...], panelType: '...' } or null.
     */
    getPanelHighlightInfo = () => {
        const { logicSteps, stepsSlideIndex, microSlides } = this.state
        if (!this.isTutorialMode()) return null // Not in a tutorial

        const currentLogic = this.props.logic
        if (currentLogic.bottomPanel !== 'show') {
            return { tutorialLocked: true, changedKeys: [] }
        }

        if (logicSteps.version === '2.0' && logicSteps.steps) {
            const slide = microSlides?.[stepsSlideIndex]
            const highlight = slide?.panelHighlight || null

            // Grab the exact target value the tutorial wants
            const expectedAction = this.getExpectedTutorialAction()
            const expectedValue = expectedAction?.expectedValue

            if (highlight) {
                return { ...highlight, expectedValue, tutorialLocked: true }
            }

            // Step advanced, but no new slider is highlighted -> hard lock the panel
            return { tutorialLocked: true, changedKeys: [] }
        }

        return null
    }

    // Helper: Flatten program to a list of {type} nodes in order (recursive)
    flattenProgram = (program, result = []) => {
        if (!Array.isArray(program)) return result
        program.forEach((node) => {
            result.push(node)
            if (node.subprogram) {
                this.flattenProgram(node.subprogram, result)
            }
        })
        return result
    }

    // Helper: Find what block type was added between current and expected program
    findNewBlockType = (currentProgram, expectedProgram) => {
        const currentFlat = this.flattenProgram(currentProgram)
        const expectedFlat = this.flattenProgram(expectedProgram)

        // Find the first node in expected that doesn't exist in current (by index)
        for (let i = 0; i < expectedFlat.length; i++) {
            if (!currentFlat[i]) {
                // This index doesn't exist in current — it's the new block
                return expectedFlat[i].type
            }
            if (expectedFlat[i].type !== currentFlat[i].type) {
                // Types diverge here — the expected type is the one being inserted
                return expectedFlat[i].type
            }
        }
        return null
    }

    // Helper: count total nodes in program (including subprograms)
    getFlatProgramLength = (program) => {
        if (!Array.isArray(program)) return 0
        let count = 0
        program.forEach((node) => {
            count++
            if (node.subprogram) {
                count += this.getFlatProgramLength(node.subprogram)
            }
        })
        return count
    }

    // Helper: find the hex on the board that matches the given type.
    //
    // A tutorial can contain SEVERAL blocks of the same type (e.g. two Decision
    // blocks). Returning the right-most match is ambiguous — it can't tell the
    // 1st Decision from the 2nd — which is what let the 2nd Decision's panel bind
    // to the 1st Decision's node. So we collect ALL matches, order them by their
    // rendered position (column, then row = placement order left→right), and
    // return the `occurrenceIndex`-th one. `occurrenceIndex` is how many blocks
    // of the same type were placed before this one (see getBlockTypeOccurrenceIndex).
    //
    // `board` defaults to the live module-level drawing, but callers that build a
    // fresh drawing (e.g. clearAndRebuildToStep) can pass their own board so the
    // active coords are corrected BEFORE the first render.
    // The Decision/Condition panel (if_O) is shared by these AST types. Critically,
    // a block placed as 'condition' MUTATES to 'sensor' the moment the user edits it
    // (if_O.onChange bubbles type='sensor', and bottomPanelChange writes it back).
    // So we must treat them as ONE family when locating a block on the board —
    // otherwise an edited 2nd Decision stops matching type 'condition' and the
    // occurrence search collapses onto the 1st Decision.
    static IF_PANEL_TYPES = ['condition', 'sensor', 'if']

    _typeFamily = (type) =>
        LogicTwo.IF_PANEL_TYPES.includes(type)
            ? LogicTwo.IF_PANEL_TYPES
            : [type]

    findActionHexCoordsForType = (
        type,
        occurrenceIndex = 0,
        board,
        targetRow
    ) => {
        const searchBoard = board || (drawing && drawing.board)
        if (!searchBoard || searchBoard.length === 0) return null

        const family = this._typeFamily(type)
        const isMatch = (t) =>
            !!t &&
            (family.includes(t) || family.some((f) => t === `action_${f}`))

        let matches = []
        for (let row = 0; row < searchBoard.length; row++) {
            const boardRow = searchBoard[row]
            if (!boardRow) continue
            for (let col = 0; col < boardRow.length; col++) {
                if (isMatch(boardRow[col]?.type)) {
                    matches.push([row, col])
                }
            }
        }

        if (matches.length === 0) return null

        // The authored `row` reflects nesting depth (top-level = row 1, one level
        // deep = row 3, …), which ProgramToDrawing preserves exactly — only the
        // COLUMN shifts. Two same-type blocks can share a column but sit on
        // different rows (e.g. a wait inside a loop and a wait after it), where a
        // pure column sort would order them by row and pick the wrong occurrence.
        // So filter to the target row first; occurrence is then unambiguous within
        // it. Fall back to all matches if the row filter finds nothing (defensive).
        if (targetRow != null) {
            const rowMatches = matches.filter((m) => m[0] === targetRow)
            if (rowMatches.length > 0) matches = rowMatches
        }

        // Within a row, placement order == left→right column order.
        matches.sort((a, b) => a[1] - b[1] || a[0] - b[0])

        const idx = Math.max(occurrenceIndex, 0)
        // Do NOT clamp: if the requested occurrence isn't on the board, return
        // null (correction is skipped) rather than snapping onto the WRONG block.
        if (idx >= matches.length) return null
        return matches[idx]
    }

    // Helper: how many blocks of the SAME panel family appear in codeSteps BEFORE
    // the given codeStep. This is the 0-based occurrence index of the block being
    // configured among all same-family blocks on the board, so
    // findActionHexCoordsForType can pick the right one (1st vs 2nd Decision…).
    // When targetRow is given, only counts blocks authored on that same row, so
    // occurrence lines up with the row-filtered board search (e.g. the wait after
    // a loop is occurrence 0 on row 1, independent of the wait inside the loop).
    getBlockTypeOccurrenceIndex = (codeStepIndex, internalType, targetRow) => {
        const codeSteps = this.state.logicSteps?.steps
        if (!codeSteps || codeStepIndex == null) return 0
        const JSON_TO_INTERNAL = {
            action: 'hardware',
            decision: 'condition',
            stop: 'end',
        }
        const family = this._typeFamily(internalType)
        let count = 0
        for (let i = 0; i < codeStepIndex && i < codeSteps.length; i++) {
            const bt = codeSteps[i].blockType
            const it = JSON_TO_INTERNAL[bt] || bt
            if (!family.includes(it)) continue
            if (
                targetRow != null &&
                codeSteps[i].gridPosition?.row !== targetRow
            ) {
                continue
            }
            count++
        }
        return count
    }

    // Helper: locate the "Select" hex on the rendered board. It appears as
    // 'active_hand' (chooser closed) or 'highlighted_hand' (chooser open). Like
    // container blocks, its column is shifted by the grid-gap logic when earlier
    // container blocks widen the board, so the static JSON coords go stale.
    findSelectHexCoords = () => {
        if (!drawing || !drawing.board || drawing.board.length === 0)
            return null
        for (let row = 0; row < drawing.board.length; row++) {
            for (let col = drawing.board[row].length - 1; col >= 0; col--) {
                const t = drawing.board[row][col]?.type
                if (t === 'active_hand' || t === 'highlighted_hand')
                    return [row, col]
            }
        }
        return null
    }

    // Helper: internal AST type of the block being configured on a tutorial slide
    getTutorialActiveBlockType = (slideIndex) => {
        const { logicSteps, microSlides } = this.state
        if (!logicSteps?.steps || !logicSteps?.version || !microSlides) return null
        const slide = microSlides[slideIndex]
        if (!slide) return null
        const codeStep = logicSteps.steps[slide.codeStepIndex]
        if (!codeStep) return null
        const JSON_TO_INTERNAL = {
            action: 'hardware',
            decision: 'condition',
            stop: 'end',
        }
        return JSON_TO_INTERNAL[codeStep.blockType] || codeStep.blockType
    }

    /**
     * MAGIC GRID SHIFT FIX (for `active`).
     *
     * The replay engine derives `logic.active` from the static gridPosition in
     * the tutorial JSON. But container blocks (condition/loop/sensor/variable/if)
     * and anything placed after them are laid out with a column gap
     * (see ProgramToDrawing `setCurCol(maxCols + 2)`), so their real rendered
     * column differs from the static coords. When `active` lands on the resulting
     * blank cell, the panel-open guard in render() forces bottomPanel to 'none'
     * and the configured block never opens.
     *
     * This snaps `active` onto the block's TRUE rendered coordinates (found the
     * same way getHexToHighlight corrects the highlight box). Only runs while a
     * config panel is meant to be open, and is a no-op when the static coords are
     * already correct (e.g. the first/unshifted block).
     *
     * @returns {Array|null} corrected [row, col], or null if no correction needed
     */
    correctTutorialActiveCoords = (activeLogic, slideIndex) => {
        if (!this.isTutorialMode()) return null

        const { microSlides } = this.state
        const slide = microSlides?.[slideIndex]
        if (!slide) return null

        const active = activeLogic?.active
        if (!active || active[0] === -1 || active[1] === -1) return null

        // Case 1 — a config panel should be open on the just-placed block.
        if (activeLogic.bottomPanel === 'show') {
            const internalType = this.getTutorialActiveBlockType(slideIndex)
            if (!internalType) return null

            // Pick the SAME occurrence of the type this slide configures, scoped
            // to the authored row, so the panel binds to the correct block (1st vs
            // 2nd Decision, or the wait after a loop vs inside it) rather than
            // whichever renders furthest right / on another row.
            const codeStep =
                this.state.logicSteps?.steps?.[slide.codeStepIndex]
            const targetRow = codeStep?.gridPosition?.row
            const occurrenceIndex = this.getBlockTypeOccurrenceIndex(
                slide.codeStepIndex,
                internalType,
                targetRow
            )
            const trueCoords = this.findActionHexCoordsForType(
                internalType,
                occurrenceIndex,
                undefined,
                targetRow
            )
            if (!trueCoords) return null
            if (trueCoords[0] === active[0] && trueCoords[1] === active[1])
                return null

            return trueCoords
        }

        // Case 2 — the Select chooser should open on the true Select hex.
        // The static gridPosition can point at a blank cell once earlier
        // container blocks shift the grid, leaving the chooser closed.
        if (slide.phase === 'select_active') {
            const selCoords = this.findSelectHexCoords()
            if (!selCoords) return null
            if (selCoords[0] === active[0] && selCoords[1] === active[1])
                return null

            return selCoords
        }

        return null
    }

    render = () => {
        // Hold the board until the target step has been built. On a fresh
        // navigation into this screen, Redux still holds the PREVIOUS visit's
        // program, which would flash for ~1s until loadLogicSteps rebuilds the
        // correct step. Gate only in Make/tutorial mode (where steps drive the
        // board); standalone use renders immediately as before.
        if ((this.context?.isMake || this.props.data) && !this.state.stepsReady) {
            return (
                <div
                    style={{
                        width: '100%',
                        height: '100%',
                        backgroundColor: '#FCFCFC',
                    }}
                />
            )
        }

        let connectedDevice = sessionStorage.getItem('connectedDevice')
        console.log('Logic CONDITION PROPS', this.props)
        // const connectedDevice = sessionStorage.getItem('connectedDevice')
        const {
            program,
            scale = 1,
            offset = { left: 0, top: 0 },
            currentProgramGuide,
            active,
        } = this.props.logic
        const languageName = this.props.device.language
        let microPython
        try {
            microPython = JSON.parse(sessionStorage.getItem('microPython'))
        } catch (e) {
            microPython = false
        }

        // Restore drawing.activeRef from currentActiveHexBlock (for tutorial replay)
        // When a step is replayed and currentActiveHexBlock is set, we need to populate
        // drawing.activeRef.state so the Output component can display the correct state
        const currentActiveHexBlockStr = sessionStorage.getItem(
            'currentActiveHexBlock'
        )
        if (currentActiveHexBlockStr && drawing && program) {
            try {
                const currentActiveHexBlock = JSON.parse(
                    currentActiveHexBlockStr
                )
                if (currentActiveHexBlock && currentActiveHexBlock.id) {
                    const activeRef = drawing.activeRef
                    // The live, coordinate-resolved active node's OWN id.
                    const activeLiveId = activeRef?.id

                    // currentActiveHexBlock is a SINGLE global sessionStorage slot
                    // that can lag behind the active block — while the 2nd Decision
                    // (id 12) is open it may still hold the 1st Decision (id 11).
                    // The old code applied it whenever *any* program hex shared that
                    // id, overwriting the live active node's state with a previous
                    // block's data (the flash) and even re-stamping the node's id
                    // (so drags then edited the wrong block). Only trust the snapshot
                    // when it actually describes the CURRENTLY active node.
                    const idMatches =
                        activeLiveId != null &&
                        String(activeLiveId) ===
                            String(currentActiveHexBlock.id)

                    if (
                        idMatches &&
                        activeRef &&
                        currentActiveHexBlock.state
                    ) {
                        activeRef.type = currentActiveHexBlock.type
                        activeRef.state = currentActiveHexBlock.state
                        activeRef.nodeId = currentActiveHexBlock.id
                    }
                }
            } catch (e) {
                console.log('Error restoring currentActiveHexBlock:', e)
            }
        }

        // Slide/Steps variables
        const stepsData = this.state.logicSteps
        const activeSlideIndex = this.state.stepsSlideIndex
        const totalSlides = this.getStepsSlideCount(stepsData)
        const isUploadStep = activeSlideIndex === totalSlides
        const uploadDone = isUploadStep && this.state.hasUploaded

        // Get display info (title + message) based on the data format
        let slideTitle = ''
        let slideInstruction = ''
        const microSlides = this.state.microSlides

        if (activeSlideIndex === totalSlides) {
            slideTitle = uploadDone
                ? (stepsData?.finalStepTitle || 'Excellent!')
                : (stepsData?.uploadStepTitle || 'Upload Code')
            slideInstruction = uploadDone
                ? 'Excellent! Program uploaded. Proceeding to results…'
                : (stepsData?.uploadStepInstruction || stepsData?.finalStepInstruction2 || 'Upload the code to the device to see it in action!')
        } else if (activeSlideIndex === totalSlides + 1) {
            slideTitle = stepsData?.uploadStepTitle || 'Upload Code'
            slideInstruction =
                stepsData?.uploadStepInstruction ||
                stepsData?.finalStepInstruction2 ||
                'Please upload the code to see it in action!'
        } else if (
            stepsData?.version === '2.0' &&
            microSlides &&
            microSlides.length > 0
        ) {
            // v2.0 format: use micro-slide data
            const currentMicroSlide = microSlides[activeSlideIndex]
            if (currentMicroSlide) {
                slideTitle = currentMicroSlide.title
                slideInstruction = currentMicroSlide.instruction
            }
        } else if (stepsData?.version === '2.0' && stepsData?.steps) {
            // v1.0 legacy format
            const activeStep = stepsData.steps[activeSlideIndex]
            slideTitle = activeStep?.title ?? ''
            slideInstruction = activeStep ? activeStep.instruction : ''
        }

        const { slideDir } = this.state

        var tempData
        countLogic = 0
        //description
        if (localStorage.getItem('programMode') == 'learn') {
            this.state.tutorialDesc.map((value, index) => {
                // (value.type == "hardware" || value.type == "variable" || value.type == "wait") ? this.output(value) : (value.type == "sensor" || value.type == "variable") ? this.if(value) : ""
                // return <div>{index}{value.type}</div>
                if (countLogic == 0) {
                    if (program[index]) {
                        if (program[index].type != 'start') {
                            if (program[index].type == value.type) {
                                // console.log("program check khushboo", value, program[index].state, countLogic, JSON.stringify(program[index].state) == JSON.stringify(value.state))
                                // _.isEqual(program[index].state, value.state);
                                if (
                                    _.isEqual(program[index].state, value.state)
                                ) {
                                    if (value.subprogram !== undefined) {
                                        value.subprogram.map(
                                            (value1, indexSub) => {
                                                if (
                                                    program[index].subprogram[
                                                        indexSub
                                                    ] &&
                                                    value.subprogram[indexSub]
                                                ) {
                                                    if (
                                                        program[index]
                                                            .subprogram[
                                                            indexSub
                                                        ].type ==
                                                        value.subprogram[
                                                            indexSub
                                                        ].type
                                                    ) {
                                                        if (
                                                            _.isEqual(
                                                                program[index]
                                                                    .subprogram[
                                                                    indexSub
                                                                ].state,
                                                                value
                                                                    .subprogram[
                                                                    indexSub
                                                                ].state
                                                            )
                                                        ) {
                                                            // countLogic++
                                                            // tempData = (value.type == "hardware" || value.type == "variable" || value.type == "wait") ? this.output(value, "state") : (value.type == "sensor" || value.type == "variable") ? this.if(value) : ""
                                                        } else {
                                                            countLogic++
                                                            tempData =
                                                                value
                                                                    .subprogram[
                                                                    indexSub
                                                                ].type ==
                                                                    'hardware' ||
                                                                value
                                                                    .subprogram[
                                                                    indexSub
                                                                ].type ==
                                                                    'variable' ||
                                                                value
                                                                    .subprogram[
                                                                    indexSub
                                                                ].type == 'wait'
                                                                    ? this.output(
                                                                          value
                                                                              .subprogram[
                                                                              indexSub
                                                                          ],
                                                                          'state'
                                                                      )
                                                                    : value.type ==
                                                                            'sensor' ||
                                                                        value.type ==
                                                                            'variable'
                                                                      ? this.if(
                                                                            value,
                                                                            'state'
                                                                        )
                                                                      : ''
                                                        }
                                                    } else {
                                                        countLogic++
                                                        tempData =
                                                            value.subprogram[
                                                                indexSub
                                                            ].type ==
                                                                'hardware' ||
                                                            value.subprogram[
                                                                indexSub
                                                            ].type ==
                                                                'variable' ||
                                                            value.subprogram[
                                                                indexSub
                                                            ].type == 'wait'
                                                                ? this.output(
                                                                      value
                                                                          .subprogram[
                                                                          indexSub
                                                                      ]
                                                                  )
                                                                : value.type ==
                                                                        'sensor' ||
                                                                    value.type ==
                                                                        'variable'
                                                                  ? this.if(
                                                                        value,
                                                                        'subprogram'
                                                                    )
                                                                  : ''
                                                    }
                                                } else {
                                                    countLogic++
                                                    tempData =
                                                        value.subprogram[
                                                            indexSub
                                                        ].type == 'hardware' ||
                                                        value.subprogram[
                                                            indexSub
                                                        ].type == 'variable' ||
                                                        value.subprogram[
                                                            indexSub
                                                        ].type == 'wait'
                                                            ? this.output(
                                                                  value
                                                                      .subprogram[
                                                                      indexSub
                                                                  ]
                                                              )
                                                            : value.type ==
                                                                    'sensor' ||
                                                                value.type ==
                                                                    'variable'
                                                              ? this.if(
                                                                    value,
                                                                    'subprogram'
                                                                )
                                                              : ''
                                                }
                                            }
                                        )
                                    }
                                    // countLogic++
                                    // tempData = (value.type == "hardware" || value.type == "variable" || value.type == "wait") ? this.output(value, "state") : (value.type == "sensor" || value.type == "variable") ? this.if(value) : ""
                                } else {
                                    countLogic++
                                    tempData =
                                        value.type == 'hardware' ||
                                        value.type == 'variable' ||
                                        value.type == 'wait'
                                            ? this.output(value, 'state')
                                            : value.type == 'sensor' ||
                                                value.type == 'variable'
                                              ? this.if(value, 'state')
                                              : ''
                                }
                            } else {
                                countLogic++
                                tempData =
                                    value.type == 'hardware' ||
                                    value.type == 'variable' ||
                                    value.type == 'wait'
                                        ? this.output(value)
                                        : value.type == 'sensor' ||
                                            value.type == 'variable'
                                          ? this.if(value)
                                          : ''
                            }
                        }
                    } else {
                        countLogic++

                        tempData =
                            value.type == 'hardware' ||
                            value.type == 'variable' ||
                            value.type == 'wait'
                                ? this.output(value)
                                : value.type == 'sensor' ||
                                    value.type == 'variable'
                                  ? this.if(value)
                                  : ''
                    }
                }
                // tempData = <div>hye</div>
            })
        }
        // As according to app approx 11.5 hexagons in a row in the display

        defaultScale = SizesHelper.width / (18.5 * Sizes.xdiff)
        var { bottomPanel } = this.props.logic

        const { height, width } = this.props.assembly

        var value = {}
        var current = ''
        var App = this.props.app
        var LogicFlowButtons
        var logicEditorScreenType = this.state.currentLogicScreen
        var assemblyData = this.props.assembly // Fallback to Redux if session storage fails

        try {
            const sessionData = JSON.parse(
                sessionStorage.getItem('assemblyTwo')
            )
            // Ensure session data exists and has the required structure
            if (
                sessionData &&
                sessionData.workspace &&
                sessionData.PortConnections
            ) {
                assemblyData = sessionData
            }
        } catch (e) {
            console.log('Error reading assemblyTwo from Session Storage:', e)
        }

        var { components } = assemblyData.workspace
        var { PortConnections } = assemblyData

        // Object.keys(PortConnections).map(port => PortConnections[port] = null);
        Object.keys(components).map((type) => {
            components[type].map((component, index) => {
                if (type == 'dc_motor' && component.connectedTo == 'A2') {
                    PortConnections[component.connectedTo] = { type, index }
                    index = index + 1
                    PortConnections['A1'] = { type, index }
                }
                if (type == 'dc_motor' && component.connectedTo == 'A3') {
                    PortConnections[component.connectedTo] = { type, index }
                    index = index + 1
                    PortConnections['A4'] = { type, index }
                }
                if (type == 'dc_motor' && component.connectedTo == 'F1') {
                    PortConnections[component.connectedTo] = { type, index }
                    index = index + 1
                    PortConnections['F2'] = { type, index }
                }
                if (type == 'dc_motor' && component.connectedTo == 'G1') {
                    PortConnections[component.connectedTo] = { type, index }
                    index = index + 1
                    PortConnections['G2'] = { type, index }
                } else if (connectedDevice !== 'Atr') {
                    PortConnections[component.connectedTo] = { type, index }
                }
            })
        })

        if (active) {
            if (active[0] !== -1)
                current = drawing.board[active[0]][active[1]].type
        }

        //console.log("curdraw", row);
        for (var row in drawing.board) {
            for (var i in drawing.board[row]) {
                //console.log("curdraw", drawing.board[row][i]);
                var block = drawing.board[row][i].type
                if (block == 'active_hand') {
                    i++
                    block = drawing.board[row][i].type
                    console.log('active end', block)
                    if (block.startsWith('end')) {
                        // console.log("active final", drawing.board[row][i]);
                        //drawing.board[row][i] = { type: "blank" };
                    }
                }
            }
        }
        // console.log("curdraw", drawing, active);
        if (
            current === 'blank' ||
            current === 'active_hand' ||
            current === '' ||
            current === 'hand' ||
            current === 'highlighted_hand' ||
            current == 'action'
        )
            bottomPanel = 'none'

        if (drawing && drawing.activeRef?.state) {
            value = drawing.activeRef.state
        }
        // Ensure activeRef exists before assigning to its state
        if (drawing?.activeRef && !drawing.activeRef.state) {
            drawing.activeRef.state = {}
        }
        if (this.state.detected == true) {
            var imageURL = 'images/Learn/ble_connection.png'
        } else {
            imageURL = 'images/Learn/ble_disconnection.png'
        }
        newId = newArr.push(Math.floor(Math.random() * 1000000000000))

        console.log('DRAWING REF', drawing.activeRef)
        const { slideDirection } = this.state

        let expectedAction = null
        if (this.isTutorialMode()) {
            expectedAction = this.getExpectedTutorialAction()
        }

        // --- NEW: Detect mode from URL ---
        // Note: If using a class component and React Router, checking history.location is safer
        const searchString =
            this.props.history?.location?.search || window.location.search
        const urlParams = new URLSearchParams(searchString)
        const isPreviewMode = urlParams.get('preview') === 'true'

        return (
            <div className="logic-app-container" ref={this.appContainerRef}>
                {/* --- NEW: Click Anywhere Overlay --- */}
                {expectedAction?.type === 'CLICK_ANYWHERE' && (
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            zIndex: 10 /* Covers the HexBoard, but stays beneath Subtitles/Footer */,
                            // cursor: 'pointer',
                        }}
                        onClick={() => {
                            this.advanceTutorialStep()
                        }}
                    >
                        {/* Optional subtle visual hint floating near the bottom */}
                        <div
                            style={{
                                position: 'absolute',
                                bottom: '12%',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                background: 'rgba(0,0,0,0.6)',
                                color: 'white',
                                padding: '8px 16px',
                                borderRadius: '20px',
                                fontSize: '0.9rem',
                                animation: 'pulse 1.5s infinite',
                            }}
                        >
                            Click anywhere to continue
                        </div>
                    </div>
                )}

                {/* --- NEW: Floating Exit Preview Button --- */}
                {isPreviewMode && (
                    <button
                        onClick={() => this.props.history.goBack()}
                        style={{
                            position: 'fixed',
                            top: '12vh', // Placed just below the 10vh header
                            right: '30px',
                            zIndex: 999999, // Ensure it's above the coding blocks
                            background: '#ef4444',
                            color: 'white',
                            border: 'none',
                            padding: '12px 24px',
                            borderRadius: '50px',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            boxShadow: '0 4px 15px rgba(239, 68, 68, 0.4)',
                            fontSize: '14px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                        }}
                    >
                        <MdOutlineArrowBack size={18} /> Exit Preview
                    </button>
                )}

                {!this.context?.setHeaderProps && (
                    <div
                        className="Select_Headers"
                        style={{ position: 'relative' }}
                    >
                        {this.context || isPreviewMode ? (
                            <MakeHeader
                                showTimeline={true}
                                title={
                                    this.state.logicSteps?.meta?.title || 'Toki'
                                }
                                showJumpTo={false}
                                titlePosition="left"
                                help_btnPosition="right"
                                isGoBack={true}
                                showSave={true}
                                showHexHelp={true}
                                showBluetoothBtn={true}
                                isSaveToBoard={this.getIsSaveToBoard()}
                                isShowNewUI={true}
                                fileSaveClick={() =>
                                    this.setState({ filePopup: true })
                                }
                                currentStep={this.state.stepsSlideIndex + 1}
                                totalSteps={this.getStepsSlideCount(
                                    this.state.logicSteps
                                )}
                                stepTitles={
                                    this.state.microSlides &&
                                    this.state.microSlides.length > 0
                                        ? this.state.microSlides.map(
                                              (slide) => slide?.title || ''
                                          )
                                        : this.state.logicSteps?.steps?.map(
                                              (step) => step?.title || ''
                                          ) || []
                                }
                                onStepClick={(stepNum) => {
                                    ContentEngine.breakSequentialChain()
                                    const slideIndex = stepNum - 1
                                    this.clearAndRebuildToStep(slideIndex)
                                    this.setState({
                                        stepsSlideIndex: slideIndex,
                                        showSubtitleDisplay: true,
                                    })
                                    if (this.state.aiVoiceover) {
                                        this.playAudioForStep(slideIndex)
                                    }
                                }}
                            />
                        ) : (
                            <MakeHeader
                                title={
                                    this.state.logicSteps?.meta?.title
                                        ? this.state.logicSteps.meta.title
                                        : this.state.logicSteps?.title
                                          ? this.state.logicSteps.title
                                          : ''
                                }
                                showJumpTo={true}
                                data={{
                                    options: [
                                        'Mechanical',
                                        'Electronic',
                                        'Coding',
                                        'Simulate',
                                    ],
                                    selected: 2, // Logic Tab
                                    isCustomHeader: true,
                                }}
                                onJumpClick={this.handleHeaderTabClick}
                                titlePosition="left"
                                help_btnPosition="right"
                                isGoBack={true}
                                goBack={this.goBack}
                                showSave={true}
                                showHexHelp={true}
                                showBluetoothBtn={true}
                                isSaveToBoard={this.getIsSaveToBoard()}
                                isShowNewUI={true}
                                fileSaveClick={() =>
                                    this.setState({ filePopup: true })
                                }
                            />
                        )}
                    </div>
                )}

                <div
                    style={{
                        position: 'relative',
                        width: '100%',
                        height: '100%',
                        overflow: 'hidden',
                    }}
                >
                    {/* AI Speaking Pill / Subtitle Box — morphs between shapes */}
                    <div
                        ref={this.subtitleRef}
                        style={{
                            position: 'absolute',
                            top: '10px',
                            left: '50%',
                            transform: !this.state.subtitleVisible
                                ? 'translateX(-50%) translateY(-120vh)'
                                : 'translateX(-50%)',
                            maxWidth: !this.state.showSubtitleDisplay
                                ? '280px'
                                : '600px',
                            maxHeight: !this.state.showSubtitleDisplay
                                ? '44px'
                                : '150px',
                            borderRadius: !this.state.showSubtitleDisplay
                                ? '20px'
                                : '20px',
                            padding: !this.state.showSubtitleDisplay
                                ? '0 18px'
                                : '12px 24px',
                            background: !this.state.showSubtitleDisplay
                                ? 'rgba(60, 60, 120, 0.13)'
                                : 'rgba(255, 255, 255, 0.3)',
                            backdropFilter: 'blur(10px)',
                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                            border: '1px solid rgba(0, 0, 0, 0.08)',
                            display: 'grid',
                            gridTemplateRows: !this.state.showSubtitleDisplay
                                ? '44px'
                                : 'auto',
                            alignItems: 'center',
                            justifyItems: 'center',
                            overflow: 'hidden',
                            zIndex: 1000001,
                            cursor: !this.state.showSubtitleDisplay
                                ? 'pointer'
                                : 'default',
                            opacity: !this.state.subtitleVisible ? 0 : 1,
                            pointerEvents: !this.state.subtitleVisible
                                ? 'none'
                                : 'auto',
                            transition: [
                                'transform 1s cubic-bezier(0.4, 0, 0.2, 1)',
                                'max-width 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                                'max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                                'border-radius 0.45s ease',
                                'padding 0.4s ease',
                                'background 0.45s ease',
                                'opacity 0.6s ease',
                            ].join(', '),
                        }}
                        onClick={
                            !this.state.showSubtitleDisplay
                                ? () =>
                                      this.setState({
                                          showSubtitleDisplay: true,
                                      })
                                : undefined
                        }
                    >
                        {/* Pill content — visible when collapsed */}
                        <div
                            style={{
                                gridArea: '1/1',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px',
                                fontWeight: 600,
                                fontSize: '1rem',
                                color: '#2f2e65',
                                fontFamily: 'Halcyon_SemiBold, sans-serif',
                                whiteSpace: 'nowrap',
                                opacity: !this.state.showSubtitleDisplay
                                    ? 1
                                    : 0,
                                transition: 'opacity 0.2s ease',
                                transitionDelay: !this.state.showSubtitleDisplay
                                    ? '0.25s'
                                    : '0s',
                                pointerEvents: 'none',
                            }}
                        >
                            <BsStars size={20} style={{ color: '#2f2e65' }} />
                            {this.state.aiVoiceover
                                ? 'AI is speaking...'
                                : 'Click to expand'}
                        </div>
                        {/* Subtitle text — visible when expanded */}
                        <div
                            style={{
                                gridArea: '1/1',
                                fontSize: '1.1rem',
                                color: '#333',
                                wordBreak: 'break-word',
                                whiteSpace: 'pre-wrap',
                                fontFamily: 'Halcyon Regular, sans-serif',
                                lineHeight: '1.5',
                                textAlign: 'center',
                                opacity: !this.state.showSubtitleDisplay
                                    ? 0
                                    : 1,
                                transition: 'opacity 0.2s ease',
                                transitionDelay: !this.state.showSubtitleDisplay
                                    ? '0s'
                                    : '0.25s',
                                pointerEvents: 'none',
                                width: '100%',
                            }}
                        >
                            {this.state.aiVoiceover
                                ? this.state.typewriterText
                                : slideInstruction}
                        </div>
                    </div>

                    {/* <div className="XXX">HELLO BUDDY</div> */}
                    <div onWheel={this.wheel}>
                        <Hammer
                            onPan={this.pan}
                            onPanStart={this.panStart}
                            onPanEnd={this.panEnd}
                            onPinchIn={this.pinchIn}
                            onPinchOut={this.pinchOut}
                            options={{
                                recognizers: {
                                    pinch: { enable: true },
                                },
                            }}
                        >
                            <div
                                className="draw"
                                style={{
                                    height: '1000px',
                                }}
                            >
                                {/* <img
                  style={{
                    position: "absolute",
                    top: "4.8%",
                    rotate: "-90deg",
                    left: "36.5%",
                  }}
                  src={renderPrgImage("StartArrow")}
                ></img> */}
                                <svg
                                    height="100%"
                                    width="100%"
                                    style={{
                                        backgroundColor: '#FCFCFC',
                                        // pointerEvents: 'none',    // Use this to disable all clicks
                                    }}
                                    className="noselect"
                                >
                                    <g
                                        transform={
                                            'scale(' + defaultScale + ')'
                                        }
                                    >
                                        <g
                                            transform={'scale(' + scale + ')'}
                                            id="logicScaleTransformer"
                                        >
                                            <g
                                                transform={
                                                    'translate(' +
                                                    offset.left +
                                                    ',' +
                                                    offset.top +
                                                    ')'
                                                }
                                                id="logicOffsetTransformer"
                                            >
                                                <HexBoard
                                                    hexType={this.state.hexType}
                                                    drawing={drawing}
                                                    onClick={this.click}
                                                    onDoubleClick={
                                                        this.toggleBottomPanel
                                                    }
                                                    // onClick={this.ITS}
                                                    id={IDIS}
                                                    highlightHex={this.getHexToHighlight()}
                                                />
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                                {/* <div style={{ height: "10%", width: "65%", border: "2px solid #bed5fa", backgroundColor: "white", borderRadius: "20px", top: "80vh", left: "10%", position: 'inherit' }}>
                <h3 style={{ marginLeft: "20px", marginTop: "2px" }}>
                  {Object.entries(this.state.tutorialDesc).map(([key, value]) => {
                    console.log("logic Connections 2", key, value)
                    return < div> {parseInt(key) + 1}. {value}</div>
                  })}
                </h3>
              </div> */}

                                {localStorage.getItem('programMode') ==
                                    'learn' && tempData ? (
                                    <div
                                        style={{
                                            height: 'auto',
                                            width: '65vw',
                                            border: '2px solid #bed5fa',
                                            backgroundColor: 'white',
                                            borderRadius: '20px',
                                            bottom: '3%',
                                            left: '17%',
                                            position: 'fixed',
                                        }}
                                    >
                                        <h3
                                            style={{
                                                marginLeft: '20px',
                                                marginTop: '2px',
                                            }}
                                        >
                                            {/* {this.state.tutorialDesc[0].type} */}

                                            {/* {Object.entries(this.state.tutorialDesc).map(([key, value]) => {
                    console.log("logic Connections 2", key, value)
                    return < div> {key}. {value}</div>
                  })} */}

                                            {/* {this.state.tutorialDesc.map((value, index) => {
                    console.log("program check", program[index].type)
                    return (value.type == "hardware" || value.type == "variable" || value.type == "wait") ? this.output(value) : (value.type == "sensor" || value.type == "variable") ? this.if(value) : ""
                    // return <div>{index}{value.type}</div>
                  })} */}
                                            {tempData}
                                        </h3>
                                    </div>
                                ) : (
                                    ''
                                )}
                            </div>
                        </Hammer>
                    </div>

                    {/* 3c. Right Toolbar */}
                    {!this.context?.setHeaderProps && (
                        <div className="toolbar-sidebar">
                            <button
                                className={`toolbar-button ${this.state.aiVoiceover ? 'active' : ''}`}
                                title="AI Voiceover"
                                onClick={() => {
                                    this.handleAiVoiceoverToggle()
                                    this.setState({
                                        subtitleVisible:
                                            !this.state.aiVoiceover,
                                        showSubtitleDisplay:
                                            !this.state.aiVoiceover,
                                    })
                                }}
                            >
                                <BsStars />
                            </button>
                            <button
                                className="toolbar-button"
                                title="Fullscreen"
                                onClick={this.handleFullscreen}
                            >
                                <MdFullscreen />
                            </button>
                            <button
                                className="toolbar-button"
                                title="Reset"
                                onClick={() => {
                                    this.resetTutorial()
                                }}
                            >
                                <RxReset />
                            </button>
                        </div>
                    )}

                    {/* 3d. Footer (Overlaid at bottom of content area) */}
                    {!this.context?.setHeaderProps && (
                        <footer className="footer">
                            <div className="step-counter">
                                Step {activeSlideIndex + 1} of {totalSlides + 1}
                            </div>
                            <div className="step-title">{slideTitle}</div>
                            <div className="nav-buttons">
                                <button
                                    className="nav-btn"
                                    onClick={this.handleStepsPrev}
                                    // disabled={activeSlideIndex === 0}
                                >
                                    <GrPrevious />
                                    <span className="footer-btn-text">
                                        Previous
                                    </span>
                                </button>
                                <button
                                    className="nav-btn"
                                    onClick={this.handleStepsNext}
                                >
                                    <span className="footer-btn-text">
                                        {activeSlideIndex === totalSlides
                                            ? 'Continue'
                                            : 'Next'}
                                    </span>
                                    <GrNext />
                                </button>
                            </div>
                        </footer>
                    )}

                    {/* OPEN THE PANEL THIE ACTIONS When you dubble click it will open  */}

                    <BottomPanel
                       
                        key={`bp-${
                            drawing.activeRef.nodeId ??
                            `${
                                current === 'condition' ? 'sensor' : current
                            }-${(this.props.logic.active || []).join('-')}`
                        }`}
                        componentProps={this.props.concept.componentProps}
                        PortConnections={PortConnections}
                        value={value}
                        show={bottomPanel}
                        toggle={this.toggleBottomPanel}
                        current={current}
                        state={drawing.activeRef.state}
                        nodeId={drawing.activeRef.nodeId}
                        onChange={this.bottomPanelChange}
                        startState={program[0].state}
                        hexTypeCheck={this.hexTypeCheck}
                        bottomPanelDeleteKey={this.bottomPanelDelete}
                        panelHighlightInfo={this.getPanelHighlightInfo()}
                      
                        endLocked={this.isEndToggleLocked()}
                    />

                    {/* Hidden audio element */}
                    <audio ref={this.audioRef} style={{ display: 'none' }} />

                    <SavePopUpTwo
                        showPopUp={this.state.filePopup}
                        setFilePopUp={this.setFilePopUp}
                        isNotCreateAction={true}
                        isShowNewUI={false}
                        audioFile={''}
                        setAudioFile={() => {}}
                        projectName={''}
                        programsaveToBoard={async () =>
                            await this.programsaveToBoard(microPython)
                        }
                    />

                    <DialogModal
                        show={this.state.excitDataLimitPopup}
                        text="Your current program exceed the size limit."
                        showCloseBtn={true}
                        handleDialogModalClose={this.closeExcitDataLimitPopup}
                    />
                    <DialogModal
                        show={this.state.checkEndProgram}
                        text="Please end the program with Loop or Stop."
                        showCloseBtn={true}
                        handleDialogModalClose={this.closecheckEndProgram}
                    />
                    <DialogModal
                        show={this.state.uploadOpen}
                        text={
                            this.props.webSerial.isConnected
                                ? 'Uploading Program'
                                : 'Connect your device to upload program.'
                        }
                        showCloseBtn={true}
                        handleDialogModalClose={this.closeUpload}
                    />
                    <DialogModal
                        show={this.state.uploadSucessError.isShow}
                        text={this.state.uploadSucessError.message}
                        showCloseBtn={true}
                        handleDialogModalClose={this.closeUploadSucess}
                    />
                    <DialogModal
                        show={this.state.showSkipUploadModal}
                        text="Upload your program to the device before seeing the result."
                        showCloseBtn={false}
                        optionsToSelect={[
                            {
                                text: 'Upload Now',
                                do: () => {
                                    this.setState({ showSkipUploadModal: false })
                                    this.uploadProgram({ save: false })
                                },
                            },
                            {
                                text: 'Skip & See Result',
                                do: () => {
                                    this.setState({ showSkipUploadModal: false })
                                    if (this.props.data) ContentEngine.next()
                                    else this.props.history.push('/SimulateNew')
                                },
                            },
                        ]}
                    />
                    <DialogModal
                        show={this.state.lowerVersionPcAiToolShow}
                        text={
                            <p>
                                {`AI-1 accessory is not compatible with the current firmware version. Please update the ${getDeviceName(
                                    connectedDevice
                                )} using the firmware updation tool `}
                                <a
                                    href="https://firmware.plode.org"
                                    target="_blank"
                                >
                                    Here.
                                </a>
                            </p>
                        }
                        showCloseBtn={true}
                        handleDialogModalClose={() =>
                            this.setState({ lowerVersionPcAiToolShow: false })
                        }
                    />
                    <DialogModal
                        show={this.state.clearProgramModal}
                        text="Are you sure you want to clear this program"
                        optionsToSelect={[
                            { text: 'YES', do: this.clearProgram },
                            { text: 'NO', do: this.clearProgramfalse },
                        ]}
                    />
                    <DialogModal
                        show={this.state.modalIsOpen}
                        text="Device not connected!"
                        showCloseBtn={true}
                        handleDialogModalClose={this.close}
                        optionsToSelect={[
                            {
                                text: 'Reconnect',
                                do: () => {
                                    this.props.history.push(
                                        '/deviceSelectionTwo'
                                    )
                                },
                            },
                        ]}
                    />

                    {/* Inline reconnect dialog — expansion kit only, no navigation */}
                    <DialogModal
                        show={this.state.showReconnectModal}
                        text={
                            this.state.reconnectStatus === 'scanning'
                                ? 'Scanning for device…'
                                : this.state.reconnectStatus === 'mismatch'
                                ? 'Wrong device connected!'
                                : 'Device not connected!'
                        }
                        showCloseBtn={this.state.reconnectStatus !== 'scanning'}
                        handleDialogModalClose={this.closeReconnectModal}
                        optionsToSelect={
                            this.state.reconnectStatus === 'scanning'
                                ? []
                                : this.state.reconnectStatus === 'mismatch'
                                ? [{ text: 'Try Again', do: this.handleInlineConnect }]
                                : [{ text: 'Connect Device', do: this.handleInlineConnect }]
                        }
                    >
                        {this.state.reconnectStatus !== 'scanning' && (
                            <p style={{ color: '#666', fontSize: '0.9rem', margin: '4px 0 8px' }}>
                                {this.state.reconnectStatus === 'mismatch'
                                    ? `This tutorial requires a ${getBrandDeviceName(
                                          sessionStorage.getItem('allowedDevice') || 'Toki'
                                      )}. Please connect the correct device and try again.`
                                    : `Connect your ${getBrandDeviceName(
                                          sessionStorage.getItem('allowedDevice') || 'Toki'
                                      )} via USB, then click the button below.`}
                            </p>
                        )}
                    </DialogModal>

                    {/* Back button — bottom-left, vertically aligned with upload button.
                        Hidden inside the tutorial shell (SubprogramRunner), which already
                        renders a persistent header back button; shown only in the
                        standalone hex screen so it isn't lost there. */}
                    {!this.context?.setHeaderProps && (
                        <img
                            onClick={this.goBack}
                            src={renderPrgImage('backBtn')}
                            style={{
                                position: 'absolute',
                                bottom: '3vh',
                                left: '2.7vw',
                                width: '55px',
                                height: '55px',
                                cursor: 'pointer',
                                zIndex: 1000000,
                            }}
                            alt="back"
                        />
                    )}

                    {sessionStorage.getItem('connectedDevice') === 'Ace' &&
                    !sessionStorage.getItem('deviceVersion')?.startsWith('1') &&
                    !['Roboki', 'Toki', 'Poki', 'Atr', 'Moki'].includes(
                        sessionStorage.getItem('connectedDevice')
                    ) ? (
                        <img
                            onClick={() => {
                                if (microPython) {
                                    return
                                }
                                saveToLocalStorage()
                                if (
                                    this.state.readyForSimulation !==
                                        'repeat' &&
                                    this.state.readyForSimulation !== 'end'
                                ) {
                                    this.setState({ checkEndProgram: true })
                                } else {
                                    this.uploadProgram({ save: false })
                                }
                            }}
                            className={`nextButton ${isUploadStep && !uploadDone ? 'upload-highlight' : ''}`}
                            id="uploadLogicscrn"
                            src={renderPrgImage('uploadBtn')}
                            style={{
                                visibility: 'visible',
                                top: 'auto',
                                bottom: '3vh',
                                right: '2.7vw',
                                opacity: microPython ? '0.5' : isUploadStep && !uploadDone ? '1' : '0.35',
                                cursor: isUploadStep && !uploadDone ? 'pointer' : 'default',
                                zIndex: 1000000,
                            }}
                        ></img>
                    ) : (
                        <img
                            onClick={() => {
                                if (microPython) {
                                    return
                                }
                                saveToLocalStorage()
                                if (
                                    this.state.readyForSimulation !==
                                        'repeat' &&
                                    this.state.readyForSimulation !== 'end'
                                ) {
                                    console.log('End check')
                                    this.setState({ checkEndProgram: true })
                                } else {
                                    console.log('Trying to upload program!')
                                    this.uploadProgram({ save: false })
                                }
                            }}
                            className={`nextButton ${isUploadStep && !uploadDone ? 'upload-highlight' : ''}`}
                            id="uploadLogicscrn"
                            src={renderPrgImage('uploadBtn')}
                            style={{
                                visibility: 'visible',
                                top: 'auto',
                                bottom: '3vh',
                                right: '2.7vw',
                                width: '60px',
                                height: '60px',
                                cursor: microPython || !isUploadStep || uploadDone ? 'default' : 'pointer',
                                opacity: microPython ? '0.5' : isUploadStep && !uploadDone ? '1' : '0.35',
                                zIndex: 1000000000,
                            }}
                        ></img>
                    )}

                    {this.state.isHelp && (
                        <div className="Ss_slide" style={{ left: '50%' }}>
                            <LogicPrgm />
                            <img
                                className="helpClo"
                                src={renderPrgImage('closBtn')}
                                onClick={this.helpBtn}
                            ></img>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        ...state,
        logic: state.logicTwo,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        update: (data) => {
            dispatch({ type: 'LOGIC_SELECTION_TWO', payload: data })
        },
        PortConnections: (data) => {
            dispatch({ type: 'PORT_Connection', payload: data })
        },
        updateAssemblyTwoWorkspace: (data) => {
            dispatch({ type: 'ASSEMBLY_TWO_SELECTION', payload: data })
        },
        updateAssemblyTwoPortConnections: (data) => {
            dispatch({ type: 'PORT_CONNECTION_TWO', payload: data })
        },
        updateComponentProps: (data) => {
            dispatch({ type: 'COMPONENT_PROPS', payload: data })
        },
        updateInternalAccessories: (data) => {
            dispatch({ type: 'INTERNAL_ACCESSORIES', payload: data })
        },
        updateComponentSelection: (data) => {
            dispatch({ type: 'COMPONENT_SELECTION', payload: data })
        },
        webSerialConnect: (data) => {
            dispatch(webSerialConnect(data))
        },
        deviceDetails: (data) => {
            dispatch(deviceDetails(data))
        },
        deviceMismatch: (data) => {
            dispatch(deviceMismatch(data))
        },
        setDisableAfterSettingByt: (data) => {
            dispatch({ type: 'DISABLE_AFTER_SETTING_BYTE', payload: data })
        },
        setHexActiveStep: (data) => {
            dispatch(setHexActiveStep(data))
        },
    }
}
// Logic = DragDropContext(TouchBackend({ enableMouseEvents: true }))(Logic);
LogicTwo = withRouter(DragDropContext(HTML5Backend)(LogicTwo))
LogicTwo = connect(mapStateToProps, mapDispatchToProps)(LogicTwo)
export default LogicTwo